/**
 * Dizionario completo di parole, entità, codici, brand e sigle/acronimi da anonimizzare,
 * scaricato direttamente da BigQuery dalle tabelle:
 * - tiaki-arc.output_9c9fe631e1f0b958d07f21db8b13a1f73444597c11daf0c8a6ce053eb80d3741.table_generazione_template_cliente
 * - tiaki-arc.FS_VAL_COMMERCIALE_INPUT.input_portale_di_governo
 *
 * Tutte le entità sono mappate a corrispettivi realistici immaginari (senza asterischi).
 */
export const ANONYMIZATION_DICTIONARY: Record<string, string> = {
  "tiaky": "Hyperion",
  "TIAKY": "HYPERION",
  "Tiaky": "Hyperion",
  "Mattia Giuseppe Logatto": "Edoardo Castelli",
  "Emanuele Cavallari": "Vincenzo Fiore",
  "Arsenio Raimo": "Simone Barbieri",
  "Enrico Prealta": "Fabio Gentile",
  "Flavio Ottonello": "Edoardo Castelli",
  "Pasquale Maria Mascolo Montenero": "Matteo Lombardi",
  "Paolo Fiscarelli": "Massimo Mancini",
  "Fabio Puglia": "Fabio Caruso",
  "Francesco Palmieri": "Andrea Colombo",
  "Deccio Cesare": "Tommaso Gatti",
  "Gaetano Bersani": "Filippo Marini",
  "Fabrizio Brasini": "Vincenzo Caputo",
  "Marco Martinelli": "Antonio Vitale",
  "Alexander Gamlath": "Giovanni Marini",
  "Franco Federici": "Stefano Greco",
  "Lorenzo Grande": "Antonio Vitale",
  "Marco Signorello": "Leonardo Moretti",
  "Ilario Scattone": "Andrea Vitale",
  "Christian Minciotti": "Stefano Marini",
  "Giuseppe Gabriele Francavilla": "Vincenzo Moretti",
  "Melissa Petrini": "Francesca Ferraro",
  "Aurelio Rosa": "Lorenzo Rinaldi",
  "Daniele Brunori": "Andrea Barbieri",
  "Vincenzo Gennusa": "Federico Castelli",
  "Fabrizio Muffarotto": "Paolo Monti",
  "Daniele De Livio": "Giovanni Morelli",
  "Emanuele Cammelli": "Matteo Testa",
  "Angelo Piazzolla": "Gabriele Bernardi",
  "Massimo Di Mauro": "Riccardo Fontana",
  "Cavallari Emiliano": "Giuseppe Caputo",
  "Francesco Vitagliani": "Riccardo Fontana",
  "Rossi Giacomo": "Filippo D’Angelo",
  "Mainini Davide": "Gabriele Colombo",
  "Marilena Di Gennaro": "Giorgia Monti",
  "Sobrero Mario": "Riccardo Conti",
  "Roberta Dal Zotto": "Chiara Moretti",
  "Daniele Gasbarri": "Lorenzo Colombo",
  "Luca Alberto Ciorra": "Luca Costa",
  "Marco Borghetti": "Federico Galli",
  "undefined undefined": "Stefano Ferraro",
  "Vitaletti Gabriele": "Antonio Ferrari",
  "Camerlingo Simone": "Lorenzo Lombardi",
  "Bersani Gaetano": "Giuseppe Coppola",
  "Scattone Ilario": "Filippo D’Angelo",
  "Rosa Aurelio": "Alessia Bernardi",
  "Luca Giovagnoli": "Fabio Palumbo",
  "Carnevale Simone": "Daniele Fiore",
  "Prealta Enrico": "Claudia Coppola",
  "Signorello Marco Salvatore": "Matteo Esposito",
  "Del Vecchio Roberto": "Lorenzo Bernardi",
  "Puglia Fabio": "Serena Gatti",
  "Signorello": "Gabriele Conti",
  "Ermanno Basso": "Federico Caputo",
  "Marcella Faraone": "Beatrice De Luca",
  "Parisi Leonardo": "Mattia Lombardi",
  "Federici Franco": "Lorenzo Vitale",
  "Stefano Patacconi": "Giovanni Basile",
  "Cesare Deccio": "Mattia Vitale",
  "Piazzolla Angelo": "Chiara Fiore",
  "Giovanna Lauretta": "Irene Bellini",
  "Prealta / Puglia": "Irene Fiore",
  "Palmieri Francesco": "Stefano Moretti",
  "Alessio Andreutti": "Marco Gatti",
  "Argiolas Pier Paolo": "Stefano Fontana",
  "Simone Camerlingo": "Vincenzo Riva",
  "Irene Cantoni / Vincenzo Zarrella": "Massimo Colombo",
  "Sobrero/Cammelli": "Antonio Galli",
  "Madalin Jitaru": "Alessandro Basile",
  "Dal Zotto Roberta": "Simone Colombo",
  "Logatto Mattia Giuseppe": "Andrea Barbieri",
  "Del Vecchio Roberto (ex Rosa)": "Tommaso Serra",
  "Daniele Viola": "Davide Coppola",
  "Guido Rossi": "Giovanni Ferri",
  "Roberto Del Vecchio": "Paolo Fiore",
  "Matteo Marchello": "Antonio Basile",
  "Carmela Apice": "Sara Ferraro",
  "Brasini Fabrizio": "Stefano Testa",
  "ALEXANDER GAMLATH": "Leonardo Costa",
  "Laura Peruzzi": "Chiara Gentile",
  "Alessio Ippolito": "Marco De Luca",
  "Alessandro Tuccio": "Mattia Palumbo",
  "Luciano Boccellino": "Riccardo Marini",
  "Pasquale Cartella": "Marco Fontana",
  "Gabriele Vitaletti": "Vincenzo De Luca",
  "Mario Sobrero": "Massimo Fabbri",
  "Pasquale Mascolo": "Mattia Palumbo",
  "Gabriele Durante": "Luca Caputo",
  "Aldo Vannelli": "Luca Ferrari",
  "Marco Taglienti": "Andrea D’Angelo",
  "Sara Senatore": "Federica Marini",
  "Franco Catignani": "Davide Serra",
  "Mario Dibenedetto": "Matteo Fontana",
  "Antonello Portera": "Vincenzo Greco",
  "Maurizio Nunzi": "Davide Castelli",
  "Eugenio Circosta": "Daniele Bernardi",
  "Valerio Riccardi": "Federico Coppola",
  "Davide Nisi": "Lorenzo Coppola",
  "Mauro Bracuti": "Paolo Costa",
  "Paolo Cossiga": "Daniele Rizzo",
  "Paolo Chiappinelli": "Marco Riva",
  "Marika Manzi": "Silvia Santoro",
  "Andrea Dito": "Simone Morelli",
  "Pietro Conte": "Alessandro Ferri",
  "Valeria Marocchi": "Sara Mancini",
  "Massimo Bruno": "Luca Bellini",
  "Giorgio Tartaglione": "Marco Bernardi",
  "Andrea Cavallieri": "Federico Pellegrini",
  "Filodelfo Bartolini": "Tommaso Serra",
  "Maria Antonella Paternoster": "Francesca Greco",
  "Pierdomenico Lariccia": "Giovanni Riva",
  "Costanza Lotito": "Giulia Marchetti",
  "Alessandro Blasetti": "Daniele Bellini",
  "Alessandro Cesarini": "Giovanni Coppola",
  "Roberto Milli": "Fabio Santoro",
  "Giovanni Antonelli": "Lorenzo Colombo",
  "Maurizio Perri": "Fabio Rizzo",
  "Giulia Vitti": "Giulia Galli",
  "Roberto Lopez": "Giovanni Palumbo",
  "Roberta Gemini": "Alessia Fiore",
  "Stefano Guerri": "Gabriele Ferraro",
  "E. Locuratolo": "Gabriele Galli",
  "Andrea Marzi": "Leonardo Fabbri",
  "Desiree Labate": "Riccardo Moretti",
  "Perri Maurizio": "Vincenzo De Luca",
  "Bucci Bucci": "Edoardo Bellini",
  "Andrea Gianfelici": "Edoardo Ferrari",
  "Eleonora Locuratolo": "Elena Fabbri",
  "Vittorio Magnante": "Marco Riva",
  "Carla Paladino": "Sara Marchetti",
  "Giuseppe Valentini": "Federico Ferri",
  "Stefano Accardi": "Filippo D’Angelo",
  "Bartolini": "Simone Rinaldi",
  "Maurizio Miranda": "Lorenzo Ferri",
  "Marina Ferri": "Sara Marchetti",
  "Damiano Raspollini": "Matteo Monti",
  "Stefano Mascherini": "Luca Castelli",
  "Blasetti/Bracuti": "Antonio Ferraro",
  "Letizia Pace": "Alice Gentile",
  "Ludovico Mechelli": "Vincenzo Conti",
  "Francesco Pirrone": "Lorenzo Caruso",
  "Francesco Pirrone / Tonnetti": "Andrea Barbieri",
  "Francesco Pipolo": "Matteo Esposito",
  "Alessandro Iacorossi": "Fabio Caputo",
  "Laura Cimirro": "Claudia Marini",
  "Salvatore Rocca": "Lorenzo Galli",
  "Francesco Morelli": "Federico Gatti",
  "Carmela Simini": "Elena Bellini",
  "Sara Vigarelli": "Serena De Luca",
  "Andrea Pistone": "Luca Marini",
  "Edoardo Tagliacozzo": "Edoardo Conti",
  "Alessandro Fabbrini": "Andrea Marini",
  "Francesca Debiase": "Francesca Rizzo",
  "Pasqualino Perrone": "Vincenzo Testa",
  "Ilaria Mascellani": "Beatrice Riva",
  "Marco Fontana": "Lorenzo Ferrari",
  "Antonio Lelli, GAETANO NAPOLETANO": "Lorenzo Ferri",
  "Damiano Cristini": "Antonio De Luca",
  "Agostino Di Luggo": "Antonio Caputo",
  "Davide Mainini": "Giuseppe Palumbo",
  "Roberta Torella": "Elena D’Angelo",
  "Immacolata Boggia": "Chiara Santoro",
  "Massimo Saviano": "Alessandro Greco",
  "Massimiliano Ciccozzi": "Massimo Barbieri",
  "Emiliano Cavallari": "Tommaso Fontana",
  "Generoso Parlangeli": "Alessandro Caruso",
  "Roberta Sammartino": "Chiara Riva",
  "Gianluca Filippetti": "Chiara Caruso",
  "LILIANA IANNANDREA": "Alessia Fontana",
  "Vitagliano Francesco": "Marco Caputo",
  "Bruno Ranieri": "Davide Fontana",
  "Alessandro Accogli": "Luca Fabbri",
  "VENERA BONAVENTURA": "Serena De Luca",
  "Giuliano De Angelis": "Andrea Greco",
  "Giuseppe Cappelli": "Davide Morelli",
  "Daniele Bartalesi": "Massimo Testa",
  "Giacomo Rossi": "Matteo Morelli",
  "Daniela De Santo": "Alessia Fabbri",
  "Pamela Attavilla": "Alice Fiore",
  "Valentina D'antona": "Giulia Fiore",
  "Nicola Maria Cornelio": "Federico Ferri",
  "Giampiero De Angelis": "Federico Serra",
  "Annamaria Largoni": "Anna Marini",
  "Roberto Vitale": "Mattia Testa",
  "Antonio Lelli": "Simone Fabbri",
  "Luca Massari": "Andrea Serra",
  "Francesca Salvati": "Sara Rinaldi",
  "Marco Pistone": "Filippo Fiore",
  "Stefania Ducci, Stefania Ducci, Amalia Di Taranto, Amalia Di Taranto": "Sara Marini",
  "Cristian Urbinelli": "Stefano Morelli",
  "Daniele Gasbarri, Daniele Gasbarri": "Giuseppe Caruso",
  "Carmela Apice, Carmela Apice": "Giulia Galli",
  "Marco Esposito": "Luca Marchetti",
  "Simone Rinna": "Alessandro Ferraro",
  "Fabrizio Pellegrini": "Daniele Vitale",
  "Simona Simoni": "Silvia Esposito",
  "Michele Bruno": "Fabio Fontana",
  "Marco Cipelletti": "Luca Conti",
  "Simona Malerba": "Valentina Monti",
  "Alessandro Brigo": "Edoardo Greco",
  "Stefania Ducci": "Irene Bellini",
  "Alessandro Pira": "Marco Colombo",
  "Federica Maggi": "Laura Ferrari",
  "Luca Mariorenzi": "Marco Marchetti",
  "Carmine Faggiano": "Alessandro Bernardi",
  "Manuel D'Agostino": "Lorenzo Gatti",
  "Mauro Scopel": "Lorenzo Gatti",
  "Pietro Maggiofino": "Giuseppe Lombardi",
  "Catello Cascone": "Stefano Moretti",
  "Emilia Bartolini": "Alice Lombardi",
  "Matteo Nati": "Mattia Marini",
  "Paolo Fiscarielli": "Fabio Costa",
  "Giuseppe Calarco": "Massimo Lombardi",
  "Pasquale Benedetti": "Luca Coppola",
  "Maurizio Crispo": "Edoardo Fontana",
  "Chiara La Pietra": "Chiara Bellini",
  "Roberto Guareschi": "Daniele Caputo",
  "Valentino Ranucci": "Davide Mancini",
  "Gloria Ficarra": "Beatrice Morelli",
  "Giulia Forconi": "Sara Moretti",
  "Stefano Cocchi": "Leonardo Caputo",
  "Emiliano D'Onofrio": "Leonardo Greco",
  "Alessandro Acampa": "Matteo Ferrari",
  "Emiliano Villa": "Fabio Fabbri",
  "Angelo Calabrese": "Vincenzo Morelli",
  "Andrea Bianchi": "Massimo Rinaldi",
  "Chiara Orlando": "Giulia Testa",
  "Andrea Prosposito": "Massimo Conti",
  "Antonio Barile": "Fabio Mancini",
  "Mariapia Letizia": "Martina Costa",
  "Roberto Chiari": "Fabio De Luca",
  "Davide Protasi": "Lorenzo De Luca",
  "Paola Marfella": "Claudia Fontana",
  "Giovanna Amendola": "Martina Ferraro",
  "Anna Serrani": "Francesca Galli",
  "Gabriel Petersen": "Antonio Bernardi",
  "Cristina Lamantia": "Federica Gatti",
  "Paola Ceruleo": "Elena Conti",
  "Enrico Giuffrida": "Massimo Colombo",
  "Alessia Esposito": "Elena Riva",
  "Adriana Asselti": "Claudia Coppola",
  "Francesco Ravaccia": "Luca Gatti",
  "Marco Azzuè": "Federico Esposito",
  "Maurizio Niro": "Matteo Vitale",
  "Emanuela Muscuso": "Serena Costa",
  "Gianluca Piumelli": "Irene Bellini",
  "Filippo Di Benedetto": "Fabio Ferri",
  "Emiliano Altobelli": "Filippo Barbieri",
  "Simone De Bellis": "Luca Bernardi",
  "Ermanno Basso, Patrizia Caprioli": "Stefano Riva",
  "Serena Leggeri": "Anna Monti",
  "Nicola Di Caprio": "Leonardo Costa",
  "Chiara D'Ovidio": "Martina Moretti",
  "MARYAM SADAT TABATABAEI VAEZ": "Antonio Costa",
  "Illiano Nicola": "Vincenzo Castelli",
  "Giovanni Tripodo": "Alessandro Rinaldi",
  "PDP LLOI CREW FSE": "PDP LLOI CREW MEDITERRANEA",
  "PDP SUPERVISIONE TRASPORTO REGIONALE": "VECTOR SUPERVISIONE TRASPORTO REGIONALE",
  "PDP GLMB E PLMB": "PULSE GLMB E PLMB",
  "PDP - GVT": "NEXUS - GVT",
  "ANALISI TURNAZIONE": "POLARIS_ANALISI TURNAZIONE",
  "PDP INFRASTRUTTURA APPLICATIVA 2.0 MODULO GESTIONE PROFILI": "VORTEX INFRASTRUTTURA APPLICATIVA 2.0 MODULO GESTIONE PROFILI",
  "PDP STB-FSE": "PDP STB-MEDITERRANEA",
  "PDP MODELLO DI RETE": "ORION MODELLO DI RETE",
  "PDP INFRASTRUTTURA APPLICATIVA 2.0": "CIPHER INFRASTRUTTURA APPLICATIVA 2.0",
  "PDP SUPERVISIONE TRASPORTO PASSEGGERI MASTER PDP ST-SOTI": "HYPERION SUPERVISIONE TRASPORTO PASSEGGERI MASTER PDP ST-SOTI",
  "PDP PTV": "HORIZON PTV",
  "PDP INFRASTRUTTURA APPLICATIVA 2.0 PDP INFRASTRUTTURA APPLICATIVA 2.0 MODULO": "AEGIS INFRASTRUTTURA APPLICATIVA 2.0 PDP INFRASTRUTTURA APPLICATIVA 2.0 MODULO",
  "PDP-SUPERVISIONE TRASPORTO PASSEGGERI (SISTEMA UNIFICATO)": "FORGE_PDP-SUPERVISIONE TRASPORTO PASSEGGERI (SISTEMA UNIFICATO)",
  "PDP SILVER": "AEGIS SILVER",
  "BI PISA": "NEXUS_BI PISA",
  "PDP-PNO": "ECHO_PDP-PNO",
  "TTPER - PDP LLOI CREW": "HELIOS_TTPER - PDP LLOI CREW",
  "PDP SUPERVISIONE TRASPORTO PASSEGGERI MASTER": "BEACON SUPERVISIONE TRASPORTO PASSEGGERI MASTER",
  "PDP FT": "HELIOS FT",
  "PDP ORARIO": "CIPHER ORARIO",
  "PDP SUPERVISIONE TRASPORTO PASSEGGERI MASTER PDP SUPERVISIONE TRASPORTO PASSEGGERI": "PRISM SUPERVISIONE TRASPORTO PASSEGGERI MASTER PDP SUPERVISIONE TRASPORTO PASSEGGERI",
  "PDP INTEGRATION LAYER": "PRISM INTEGRATION LAYER",
  "PISTA": "PRISM_PISTA",
  "NEW SCRIPTA": "TITAN_NEW SCRIPTA",
  "MAC": "VORTEX_MAC",
  "FN/DV": "KRYPTON_FN/DV",
  "SB-PAX": "BEACON_SB-PAX",
  "CA. FI.": "AEGIS_CA. FI.",
  "TRENITALIAINFORMA": "HELIOS_TRENITALIAINFORMA",
  "MUVI": "CORE_MUVI",
  "TMS": "SENTINEL_TMS",
  "PISA": "HORIZON_PISA",
  "TIMER": "VERTEX_TIMER",
  "CONS-LDV": "AURA_CONS-LDV",
  "SEGESTA": "TR-SYS-A",
  "VGAD": "ATLAS_VGAD",
  "INFOTREN": "ATLAS_INFOTREN",
  "GENTE": "BEACON_GENTE",
  "SAP YARD": "AEGIS_SAP YARD",
  "SDT": "VORTEX_SDT",
  "PORTALE LOGISTICA": "VERTEX_PORTALE LOGISTICA",
  "BDI": "CORE_BDI",
  "ROSA": "CORE_ROSA",
  "PIL INTEGRATION FRAMEWORK": "KRONOS_PIL INTEGRATION FRAMEWORK",
  "SAP SHUNTING": "HORIZON_SAP SHUNTING",
  "CREW MANAGEMENT - INTERFACCE": "SYNAPSE_CREW MANAGEMENT - INTERFACCE",
  "ARTU": "CORE_ARTU",
  "MOSE": "ZENITH_MOSE",
  "PICO_ITALIA": "POLARIS_CORE",
  "SYNCTRUCK": "AURA_SYNCTRUCK",
  "NEW BIT": "SPECTRA_NEW BIT",
  "SUITE EPM - PLANNING_BUDGET SISTEMI URBANI": "CIPHER_SUITE EPM - PLANNING_BUDGET SISTEMI URBANI",
  "PENTERA": "KRONOS_PENTERA",
  "ASTER SKT": "VORTEX_ASTER SKT",
  "ASTER PPC": "HORIZON_ASTER PPC",
  "ASTER M3-M40": "HELIOS_ASTER M3-M40",
  "EPOD": "KRYPTON_EPOD",
  "SALA PA": "ECHO_SALA PA",
  "SIGS WEB": "APEX_SIGS WEB",
  "TPTM FOUNDATION": "HYPERION_TPTM FOUNDATION",
  "PA - PORTALE APPLICAZIONI RFI": "PA - PORTALE APPLICAZIONI INFRARETE",
  "WEB RUMO": "ECHO_WEB RUMO",
  "GESTIONE LAN FSH": "SPECTRA_GESTIONE LAN FSH",
  "HCC CONTACT CENTER FSPARK": "ORION_HCC CONTACT CENTER FSPARK",
  "PICO3": "POLARIS-3",
  "PICO_SICUREZZA": "POLARIS_SECURITY",
  "SIREV FTP": "ORION_SIREV FTP",
  "GESTIONE MANUTENZIONE POS": "VORTEX_GESTIONE MANUTENZIONE POS",
  "APP METROPARK": "APP METROPARKING",
  "N@VIDEO": "APEX_N@VIDEO",
  "CERTIFICATION AUTHORITY INFR. VMWARE FS PARK": "TITAN_CERTIFICATION AUTHORITY INFR. VMWARE FS PARK",
  "GESPRO_OLD": "ECHO_GESPRO_OLD",
  "GESTIONE LAN TIT": "NEXUS_GESTIONE LAN TIT",
  "MCUBO VIRTUAL ENTERPRISE": "AURA_MCUBO VIRTUAL ENTERPRISE",
  "PICO4": "POLARIS-4",
  "OTRE": "HORIZON_OTRE",
  "NTS_CDORARIO": "HELIOS_NTS_CDORARIO",
  "CCN": "SPECTRA_CCN",
  "CCA FSE BUS": "CCA MEDITERRANEA BUS",
  "CCA TPL": "TITAN_CCA TPL",
  "GESTIONE SERVIZI CARROZZE RISTORAZIONE": "NOVA_GESTIONE SERVIZI CARROZZE RISTORAZIONE",
  "CCA_TPER": "TITAN_CCA_TPER",
  "FSE - AGENDE IF": "MEDITERRANEA - AGENDE IF",
  "AGENDE": "FORGE_AGENDE",
  "TTPER - AGENDE IF": "TITAN_TTPER - AGENDE IF",
  "WORKSCHEDULER FSI RISE": "SPECTRA_WORKSCHEDULER FSI RISE",
  "PICOUK_C2C": "POLARIS-UK-C2C",
  "PICOUK_AWC": "POLARIS-UK-AWC",
  "SYNCRUN": "HYPERION_SYNCRUN",
  "INFOPMS": "NEXUS_INFOPMS",
  "CRUSCOTTO SICUREZZA": "VORTEX_CRUSCOTTO SICUREZZA",
  "BI INVESTIMENTI": "SENTINEL_BI INVESTIMENTI",
  "IODA": "HELIOS_IODA",
  "RHD-CONNESSIONI ELETTRICHE": "SENTINEL_RHD-CONNESSIONI ELETTRICHE",
  "CLICK ANALYSIS": "AEGIS_CLICK ANALYSIS",
  "INFOBOARD OBEE": "HORIZON_INFOBOARD OBEE",
  "PDP-ORARIO": "TITAN_PDP-ORARIO",
  "MIR_SGI NET": "TITAN_MIR_SGI NET",
  "BDTI": "ECHO_BDTI",
  "ORFEUS": "NOVA_ORFEUS",
  "MANUTENZIONE SALE FS": "VORTEX_MANUTENZIONE SALE FS",
  "TBS": "NOVA_TBS",
  "STATION LAND": "TITAN_STATION LAND",
  "GESTIONE LAN FS SECURITY": "QUANTUM_GESTIONE LAN FS SECURITY",
  "XSB3": "PULSE_XSB3",
  "CCSC": "KRONOS_CCSC",
  "INTEGRATION SUBSYSTEM": "ORION_INTEGRATION SUBSYSTEM",
  "T-DAP": "PRISM_T-DAP",
  "GESTIONE LAN FERSERVIZI": "PULSE_GESTIONE LAN FERSERVIZI",
  "GESTIONE WAN RFI TIAKY": "GESTIONE WAN INFRARETE HYPERION",
  "GESTIONE WAN TIT TIAKY": "GESTIONE WAN TIT HYPERION",
  "CRM TI PASSEGGERI - BI MARKETING": "CIPHER_CRM TI PASSEGGERI - BI MARKETING",
  "CREW MANAGEMENT - INTERFACCE CREW MANAGEMENT IVU CONTROLLER": "PRISM_CREW MANAGEMENT - INTERFACCE CREW MANAGEMENT IVU CONTROLLER",
  "TM COMBINATO CEMAT": "SPECTRA_TM COMBINATO CEMAT",
  "SOAVE": "SENTINEL_SOAVE",
  "PDP ORARIO AREE DI STAGING": "POLARIS ORARIO AREE DI STAGING",
  "NUOVO CANALE SELF SERVICE INTEGRAZIONE TPL": "POLARIS_NUOVO CANALE SELF SERVICE INTEGRAZIONE TPL",
  "NUOVO CANALE SELF SERVICE GESTIONE MULTIBRAND": "POLARIS_NUOVO CANALE SELF SERVICE GESTIONE MULTIBRAND",
  "INTEGRAZIONE PICO": "INTEGRAZIONE POLARIS",
  "NUOVO CANALE SELF SERVICE REGIONALI": "SYNAPSE_NUOVO CANALE SELF SERVICE REGIONALI",
  "ROMAN - ROMAN PORT - ROMAN REPORT WEB": "ORION_ROMAN - ROMAN PORT - ROMAN REPORT WEB",
  "GEC(GATEWAY EXTERNAL CHANNEL)": "AURA_GEC(GATEWAY EXTERNAL CHANNEL)",
  "EVENT MANAGER PER TRACK & TRACE": "FORGE_EVENT MANAGER PER TRACK & TRACE",
  "SI.BO. (SI.CUREZZA DI BO.RDO)": "ORION_SI.BO. (SI.CUREZZA DI BO.RDO)",
  "REM-ESB 2.0": "CIPHER_REM-ESB 2.0",
  "VIAGGIA TRENO": "VECTOR_VIAGGIA TRENO",
  "TM COMBINATO MIST": "NOVA_TM COMBINATO MIST",
  "PDP COMPOSIZIONE TRASPORTI PROGRAMMATI": "HYPERION COMPOSIZIONE TRASPORTI PROGRAMMATI",
  "PIATTAFORMA TLN": "SPECTRA_PIATTAFORMA TLN",
  "TABLET": "FORGE_TABLET",
  "DIGITAL MAINTENANCE": "AURA_DIGITAL MAINTENANCE",
  "TM COMBINATO": "APEX_TM COMBINATO",
  "RFI INTEGRATION LAYER": "INFRARETE INTEGRATION LAYER",
  "WEB SARA": "AURA_WEB SARA",
  "ROMAN VCO-GVCO - CRUSCOTTO VCO": "QUANTUM_ROMAN VCO-GVCO - CRUSCOTTO VCO",
  "GEMMA IMC": "ZENITH_GEMMA IMC",
  "PDP_RVT": "SYNAPSE_PDP_RVT",
  "PREVENTIVO PEDAGGIO": "VECTOR_PREVENTIVO PEDAGGIO",
  "NUOVO CANALE SELF SERVICE PASSEGGERI": "SENTINEL_NUOVO CANALE SELF SERVICE PASSEGGERI",
  "PDP ORARIO PDP CRUSCOTTO TRENI": "VERTEX ORARIO PDP CRUSCOTTO TRENI",
  "PIATTAFORMA ADFS FSI 2.0": "PRISM_PIATTAFORMA ADFS FSI 2.0",
  "PDP FT FT PASSEGGERI": "VERTEX FT FT PASSEGGERI",
  "PDP ATP": "ORION ATP",
  "SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) TIT": "SENTINEL_SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) TIT",
  "NPP NUOVA PIATTAFORMA PALMARI": "POLARIS_NPP NUOVA PIATTAFORMA PALMARI",
  "RECAP": "VERTEX_RECAP",
  "SAP PO MERCITALIA": "BEACON_SAP PO MERCITALIA",
  "IAP SARA": "AURA_IAP SARA",
  "TBS - GESTIONE INTERFACCIA DOGANE E DAA TELEMATICO": "TITAN_TBS - GESTIONE INTERFACCIA DOGANE E DAA TELEMATICO",
  "CERTIDOC": "KRONOS_CERTIDOC",
  "CONTENT MANAGEMENT LOGISTICA": "HELIOS_CONTENT MANAGEMENT LOGISTICA",
  "ITAM RFI": "ITAM INFRARETE",
  "WMS_MOBILE": "HELIOS_WMS_MOBILE",
  "RETE BLU": "HORIZON_RETE BLU",
  "PDP STATO ROTABILE": "OMNIA STATO ROTABILE",
  "FRAUD MANAGEMENT EXCHANGE LAYER": "BEACON_FRAUD MANAGEMENT EXCHANGE LAYER",
  "PDP-DCS & PDP-SPI (INFRASTRUTTURA APPLICATIVA)": "QUANTUM_PDP-DCS & PDP-SPI (INFRASTRUTTURA APPLICATIVA)",
  "LPE-PORTALE DELLA LOGISTICA": "VECTOR_LPE-PORTALE DELLA LOGISTICA",
  "ASCOT": "HELIOS_ASCOT",
  "BI-MIR": "APEX_BI-MIR",
  "SUITE TALENTIA": "CIPHER_SUITE TALENTIA",
  "MEGA": "BEACON_MEGA",
  "SIMS": "APEX_SIMS",
  "MEGA HOPEX V3": "OMNIA_MEGA HOPEX V3",
  "MY OFFICE": "CIPHER_MY OFFICE",
  "ASTRO IF - ASTRO IF PCS": "HYPERION_ASTRO IF - ASTRO IF PCS",
  "NTS": "OMNIA_NTS",
  "PICO_FRANCE": "POLARIS_FRANCE",
  "PIATTAFORMA COMMERCIALE": "KRONOS_PIATTAFORMA COMMERCIALE",
  "SERVIZIO AV FSI": "AEGIS_SERVIZIO AV FSI",
  "C_SOC-PRESIDI": "SECURITY_HUB_PRESIDI",
  "PIC MI": "ATLAS_PIC MI",
  "PIC BDA": "KRYPTON_PIC BDA",
  "BDP": "HELIOS_BDP",
  "RPA": "VECTOR_RPA",
  "PIC WEB": "HYPERION_PIC WEB",
  "PIC RENDICONTAZIONE": "HYPERION_PIC RENDICONTAZIONE",
  "PIC GO": "APEX_PIC GO",
  "GEM": "HORIZON_GEM",
  "BDM": "QUANTUM_BDM",
  "TELEFORUM FOR": "BEACON_TELEFORUM FOR",
  "PIC SC": "NOVA_PIC SC",
  "PIC DG": "SENTINEL_PIC DG",
  "CRM TI PASSEGGERI - RECLAMI,CALL CENTER,IRIDE": "AEGIS_CRM TI PASSEGGERI - RECLAMI,CALL CENTER,IRIDE",
  "PIC RIR": "SPECTRA_PIC RIR",
  "PIC PUB": "HORIZON_PIC PUB",
  "PIC EU": "PRISM_PIC EU",
  "PIC ANALYTICS": "ZENITH_PIC ANALYTICS",
  "CRM CARGO NEW": "HYPERION_CRM CARGO NEW",
  "REDINI": "OMNIA_REDINI",
  "APPMIR": "PULSE_APPMIR",
  "DISW": "CIPHER_DISW",
  "CRM TI PASSEGGERI - LOYALTY AUC:35": "HORIZON_CRM TI PASSEGGERI - LOYALTY AUC:35",
  "MDM - BI": "SPECTRA_MDM - BI",
  "SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) RFI": "SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) INFRARETE",
  "EAA AKAMAI (NUOVA VPN)": "SENTINEL_EAA AKAMAI (NUOVA VPN)",
  "INFRASTRUTTURA ROUTING POSTA FS": "NOVA_INFRASTRUTTURA ROUTING POSTA FS",
  "TTPER - CONTRATTO RER": "KRONOS_TTPER - CONTRATTO RER",
  "DOMAIN": "NOVA_DOMAIN",
  "MA.S.T.E.R.": "HYPERION_MA.S.T.E.R.",
  "DMMS MFT FILE GATEWAY": "CORE_DMMS MFT FILE GATEWAY",
  "DATA ARCHIVING TRENITALIA": "DATA ARCHIVING VELOCERAIL",
  "IN.RETE APPROVVIGIONAMENTO E LOGISTICA": "KRONOS_IN.RETE APPROVVIGIONAMENTO E LOGISTICA",
  "SAP TIE": "PRISM_SAP TIE",
  "PPM": "KRYPTON_PPM",
  "SVR": "POLARIS_SVR",
  "IN.RETE AFC": "PULSE_IN.RETE AFC",
  "BI AFC BW-CONTROLLO": "VERTEX_BI AFC BW-CONTROLLO",
  "IN.RETE INVESTIMENTI": "VORTEX_IN.RETE INVESTIMENTI",
  "REM-ESB (IF-PIC)": "VECTOR_REM-ESB (IF-PIC)",
  "MAC MACWEB": "ATLAS_MAC MACWEB",
  "SPOT": "ATLAS_SPOT",
  "XEN CITRIX RFI": "XEN CITRIX INFRARETE",
  "RALPH": "NOVA_RALPH",
  "HIVE": "CLUSTER_METRICS",
  "WEB RADIO RFI": "WEB RADIO INFRARETE",
  "INTEGRAZIONE FLUSSI ODT (TORNELLI)": "VORTEX_INTEGRAZIONE FLUSSI ODT (TORNELLI)",
  "SEM IMPIANTI CIVILI STAZIONE": "PULSE_SEM IMPIANTI CIVILI STAZIONE",
  "CCL PERIFERICO": "NOVA_CCL PERIFERICO",
  "IAP PERIFERICO": "AURA_IAP PERIFERICO",
  "SEM IAP PERIFERICO": "HYPERION_SEM IAP PERIFERICO",
  "IEC PERIFERICO": "POLARIS_IEC PERIFERICO",
  "FERROTEL SPORTELLO ALBERGHI ON LINE": "FORGE_FERROTEL SPORTELLO ALBERGHI ON LINE",
  "B2B": "VERTEX_B2B",
  "SERVIZI APPLICATIVI": "KRONOS_SERVIZI APPLICATIVI",
  "WEB-REND": "VECTOR_WEB-REND",
  "PORTALE CLIENTI IMMOBILIARI": "SYNAPSE_PORTALE CLIENTI IMMOBILIARI",
  "SMART CARD MULTISERVIZI": "ORION_SMART CARD MULTISERVIZI",
  "CODIV-SPORTELLO WEB": "CIPHER_CODIV-SPORTELLO WEB",
  "PORTALE FORNITORI": "SENTINEL_PORTALE FORNITORI",
  "WEBBDC": "HELIOS_WEBBDC",
  "PROTON FSI": "ZENITH_PROTON FSI",
  "WEB-GDC GESTIONE DEL CREDITO": "VERTEX_WEB-GDC GESTIONE DEL CREDITO",
  "PORTALE IMMOBILIARE VENDITE E AFFITTI": "HORIZON_PORTALE IMMOBILIARE VENDITE E AFFITTI",
  "GESTIONE ASSISTITA PROGETTO VENDITA": "SYNAPSE_GESTIONE ASSISTITA PROGETTO VENDITA",
  "SERVIZI COLLATERALI ARIBA ON CLOUD": "HELIOS_SERVIZI COLLATERALI ARIBA ON CLOUD",
  "BANCA DATI DDG": "NEXUS_BANCA DATI DDG",
  "SISTEMA RUBRICAZIONE ED ARCHIVIAZIONE CONTRATTI-RUDE": "ATLAS_SISTEMA RUBRICAZIONE ED ARCHIVIAZIONE CONTRATTI-RUDE",
  "SITO WEB GRUPPO FSI -  AEM CLOUD": "AURA_SITO WEB GRUPPO FSI -  AEM CLOUD",
  "CONT_LAV CONTENZIOSO LAVORO": "VORTEX_CONT_LAV CONTENZIOSO LAVORO",
  "FERROTEL INTRANET": "HYPERION_FERROTEL INTRANET",
  "SHAREPOINT FERSERVIZI": "POLARIS_SHAREPOINT FERSERVIZI",
  "IC4X - INVOICE SCAN FOR XML": "APEX_IC4X - INVOICE SCAN FOR XML",
  "ADEMPIMENTI ASSICURATIVI": "BEACON_ADEMPIMENTI ASSICURATIVI",
  "DOCUMENTALE GO2DOC": "VERTEX_DOCUMENTALE GO2DOC",
  "SISTEMA CONTABILE FS HOLDING (FSH)": "QUANTUM_SISTEMA CONTABILE FS HOLDING (FSH)",
  "F24WEB - ADEMPIMENTI FISCALI E BILANCIO": "AURA_F24WEB - ADEMPIMENTI FISCALI E BILANCIO",
  "FSE_VALIDATORIMNG": "HYPERION_FSE_VALIDATORIMNG",
  "CA-RP": "PRISM_CA-RP",
  "IPSOA": "SENTINEL_IPSOA",
  "BDC": "NEXUS_BDC",
  "HOSTING MTRAM MAIOR": "BEACON_HOSTING MTRAM MAIOR",
  "RILEVAZIONE PRESENZE E CONTROLLO ACCESSI BUSITALIA": "RILEVAZIONE PRESENZE E CONTROLLO ACCESSI ROADRAIL",
  "APP&CAT - VESTIARIO": "CIPHER_APP&CAT - VESTIARIO",
  "BUSINESS INTELLIGENCE QLIK GESTIONE DEL CREDITO": "SYNAPSE_BUSINESS INTELLIGENCE QLIK GESTIONE DEL CREDITO",
  "SUITE EPM - TABLEAU DE BORD": "HYPERION_SUITE EPM - TABLEAU DE BORD",
  "BW RUN": "SYNAPSE_BW RUN",
  "DAM DCCEM": "VECTOR_DAM DCCEM",
  "STREAMING AKAMAI": "QUANTUM_STREAMING AKAMAI",
  "PROCURE FSH": "KRYPTON_PROCURE FSH",
  "GESTIONE ARREDI GEOCALL": "HYPERION_GESTIONE ARREDI GEOCALL",
  "FOCAL POINT": "FORGE_FOCAL POINT",
  "CAM DIGITAL SERVICES SHARED SERVICES AFFAIR MANAGEMENT": "SENTINEL_CAM DIGITAL SERVICES SHARED SERVICES AFFAIR MANAGEMENT",
  "SUITE BI RISORSE UMANE": "POLARIS_SUITE BI RISORSE UMANE",
  "HR ZUCCHETTI": "ECHO_HR ZUCCHETTI",
  "MDM": "KRYPTON_MDM",
  "SIGEL FSI": "QUANTUM_SIGEL FSI",
  "FIM-IDENTITY MANAGEMENT": "POLARIS_FIM-IDENTITY MANAGEMENT",
  "PIATTAFORMA ICLOUD ENTERPRISE DCCM": "TITAN_PIATTAFORMA ICLOUD ENTERPRISE DCCM",
  "PIATTAFORMA ICLOUD ENTERPRISE FSFONDAZIONE": "NOVA_PIATTAFORMA ICLOUD ENTERPRISE FSFONDAZIONE",
  "PIATTAFORMA SAP BI 4.0": "VECTOR_PIATTAFORMA SAP BI 4.0",
  "VIDEO PORTAL ON CLOUD": "KRYPTON_VIDEO PORTAL ON CLOUD",
  "SLM-CHARM": "ATLAS_SLM-CHARM",
  "FIM-GRUPPOFS": "TITAN_FIM-GRUPPOFS",
  "DASHBOARD RISORSE UMANE (QLIKVIEW)": "FORGE_DASHBOARD RISORSE UMANE (QLIKVIEW)",
  "WORKFLOW INTERCOMPANY": "ORION_WORKFLOW INTERCOMPANY",
  "SUITE EPM - ODI": "PRISM_SUITE EPM - ODI",
  "SUITE EPM - FDMEE": "AURA_SUITE EPM - FDMEE",
  "DAM FS FONDAZIONE": "PULSE_DAM FS FONDAZIONE",
  "FBS - FSE BUSINESS SYSTEM": "FBS - MEDITERRANEA BUSINESS SYSTEM",
  "PBCS SBU ASE (FS - FSTECH)": "PBCS SBU ASE (FS - INNOVATECH)",
  "SISTEMI EX-CENTOSTAZIONI (AMOS, CRM FM, DIOGENE, SHAREPOINT)": "TITAN_SISTEMI EX-CENTOSTAZIONI (AMOS, CRM FM, DIOGENE, SHAREPOINT)",
  "DOCUMENTALE COLPOFER": "KRONOS_DOCUMENTALE COLPOFER",
  "ITALFERR-PRESIDI": "TRANSRAIL_ENGINEERING_PRESIDI",
  "SISTEMA CONTABILE SAP BUSITALIA SIMET": "SISTEMA CONTABILE SAP ROADRAIL SIMET",
  "SISTEMA CONTABILE SAP BUSITALIA": "SISTEMA CONTABILE SAP ROADRAIL",
  "SISTEMA CONTABILE SAP UMBRIA MOBILITA'": "POLARIS_SISTEMA CONTABILE SAP UMBRIA MOBILITA'",
  "SISTEMA CONTABILE SAP BUSITALIA VENETO": "SISTEMA CONTABILE SAP ROADRAIL VENETO",
  "REM-ESB": "VECTOR_REM-ESB",
  "SERVIZIO PKI FSI": "ATLAS_SERVIZIO PKI FSI",
  "SISTEMA GESTIONE MANUTENZIONE E REAL ESTATE": "ATLAS_SISTEMA GESTIONE MANUTENZIONE E REAL ESTATE",
  "SISTEMA CONTABILE SAP GRANDI STAZIONI PRECONFIGURATO GAIA (MM/CICLO PASSIVO)": "ORION_SISTEMA CONTABILE SAP GRANDI STAZIONI PRECONFIGURATO GAIA (MM/CICLO PASSIVO)",
  "SINF - FONDO E TAV": "CORE_SINF - FONDO E TAV",
  "VIME": "PULSE_VIME",
  "VERFORM": "SYNAPSE_VERFORM",
  "SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) CEMAT": "VERTEX_SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) CEMAT",
  "SOFIA": "HYPERION_SOFIA",
  "PIATTAFORMA WINTEL": "NEXUS_PIATTAFORMA WINTEL",
  "BI AFC": "VERTEX_BI AFC",
  "NEWCO - INFRASTRUTTURA HERMES": "VECTOR_NEWCO - INFRASTRUTTURA HERMES",
  "CDVP 2.0": "HYPERION_CDVP 2.0",
  "SCCM RFI": "SCCM INFRARETE",
  "GMVP-E": "ATLAS_GMVP-E",
  "TM MERCI": "KRYPTON_TM MERCI",
  "POOLGL": "AURA_POOLGL",
  "ST@R": "TITAN_ST@R",
  "HSM (HARDWARE SECURITY MODULE)": "NEXUS_HSM (HARDWARE SECURITY MODULE)",
  "SFINGE": "VECTOR_SFINGE",
  "SITO CARGO (SISCOM)": "ATLAS_SITO CARGO (SISCOM)",
  "TMTC PERIFERICO": "PRISM_TMTC PERIFERICO",
  "GOT": "HELIOS_GOT",
  "NEW SIM": "OMNIA_NEW SIM",
  "TTPER - PROXY SOFER": "KRONOS_TTPER - PROXY SOFER",
  "PDP - MANOVRE": "ORION - MANOVRE",
  "PDP - IMC IMPIANTI MANUTENZIONE CORRENTE": "KRYPTON - IMC IMPIANTI MANUTENZIONE CORRENTE",
  "PDP-COMPOSIZIONE TRENO": "NEXUS_PDP-COMPOSIZIONE TRENO",
  "ARIBA SERVIZI ESTERNI": "AEGIS_ARIBA SERVIZI ESTERNI",
  "RHD-GSM": "HYPERION_RHD-GSM",
  "SIGS WEB - VALUTAZIONE RISCHI": "QUANTUM_SIGS WEB - VALUTAZIONE RISCHI",
  "FOCUS": "CIPHER_FOCUS",
  "CRUSCOTTO SICUREZZA CIRCOLAZIONE RFI": "CRUSCOTTO SICUREZZA CIRCOLAZIONE INFRARETE",
  "RFI METEO": "INFRARETE METEO",
  "IES": "ATLAS_IES",
  "GAMOC": "HYPERION_GAMOC",
  "SUITE SAP BI 4.1": "ECHO_SUITE SAP BI 4.1",
  "INAC 3D": "VORTEX_INAC 3D",
  "PIATTAFORMA INTEGRAZIONE PROCESSI DI INVESTIMENTO": "PRISM_PIATTAFORMA INTEGRAZIONE PROCESSI DI INVESTIMENTO",
  "RILEVAZIONE PRESENZE E CONTROLLO ACCESSI": "VECTOR_RILEVAZIONE PRESENZE E CONTROLLO ACCESSI",
  "GEOLOGIA": "SYNAPSE_GEOLOGIA",
  "GEODB MANUTENZIONE": "APEX_GEODB MANUTENZIONE",
  "SERVER LICENZE RFI": "SERVER LICENZE INFRARETE",
  "DYNAMICS CRM 2017": "ATLAS_DYNAMICS CRM 2017",
  "PIR RD": "SENTINEL_PIR RD",
  "SISTEMA PER LA PIANIFICAZIONE DEI CONSUMI ENERGETICI PER LA TRAZIONE FERROVIARIA": "PULSE_SISTEMA PER LA PIANIFICAZIONE DEI CONSUMI ENERGETICI PER LA TRAZIONE FERROVIARIA",
  "TVS DI STAZIONE": "CIPHER_TVS DI STAZIONE",
  "DBLWEB RFI": "DBLWEB INFRARETE",
  "WILIFE STATION": "VERTEX_WILIFE STATION",
  "APP PRM": "APP HORIZON_PRM",
  "DOMUS": "AURA_DOMUS",
  "GASP-NEW": "AEGIS_GASP-NEW",
  "ALTRI SISTEMI DI GESTIONE QUALITA'": "OMNIA_ALTRI SISTEMI DI GESTIONE QUALITA'",
  "ITINERE RFI": "ITINERE INFRARETE",
  "SISTEMA DI RILEVAMENTO E CONTROLLO TITOLI DI VIAGGIO - PERIFERICO": "PRISM_SISTEMA DI RILEVAMENTO E CONTROLLO TITOLI DI VIAGGIO - PERIFERICO",
  "GESTFLO": "CIPHER_GESTFLO",
  "DONET - DISTRIBUZIONE CIRCOLARI": "BEACON_DONET - DISTRIBUZIONE CIRCOLARI",
  "PIATTAFORMA DOCUMENTALE RFI": "PIATTAFORMA DOCUMENTALE INFRARETE",
  "REPORTISTICA REM": "PULSE_REPORTISTICA REM",
  "ERA SM": "AEGIS_ERA SM",
  "GASP": "KRYPTON_GASP",
  "SISMA-RFI": "SISMA-INFRARETE",
  "I-MAN": "CORE_I-MAN",
  "RHD-TIMBRATORI": "PRISM_RHD-TIMBRATORI",
  "SIGS WEB - GESTIONE PROGETTI": "AURA_SIGS WEB - GESTIONE PROGETTI",
  "ASTER QM": "FORGE_ASTER QM",
  "NUOVO MONITORAGGIO GARE": "BEACON_NUOVO MONITORAGGIO GARE",
  "PDS": "NOVA_PDS",
  "CATASTO": "VORTEX_CATASTO",
  "GESTIA - CARRELLI PRM - ALBO ISTRUTTORI": "AEGIS_GESTIA - CARRELLI PRM - ALBO ISTRUTTORI",
  "IEC HUB": "SYNAPSE_IEC HUB",
  "MONITORAGGIO ACUSTICO": "ECHO_MONITORAGGIO ACUSTICO",
  "FIRMAREMOTA-RFI": "FIRMAREMOTA-INFRARETE",
  "SIBIL": "VERTEX_SIBIL",
  "MDM - DRM": "ZENITH_MDM - DRM",
  "RHD-GSM-R": "VERTEX_RHD-GSM-R",
  "TELEDIAGNOSTICA E464 ETR-1000": "PRISM_TELEDIAGNOSTICA E464 ETR-1000",
  "SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) FSH": "APEX_SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) FSH",
  "SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) FERSERV": "AEGIS_SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) FERSERV",
  "RADIUS CENTRALI": "APEX_RADIUS CENTRALI",
  "SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) FFO": "HELIOS_SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) FFO",
  "SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) BU - SI": "APEX_SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) BU - SI",
  "WI-FI CENTRALIZZATO GRUPPO FS": "AURA_WI-FI CENTRALIZZATO GRUPPO FS",
  "SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) ITALFERR": "SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) TRANSRAIL",
  "GESTIONE INFRASTRUTTURA FSTECHNOLOGY": "GESTIONE INFRASTRUTTURA INNOVATECH",
  "SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) FSE": "SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) MEDITERRANEA",
  "FLEET MANAGEMENT - INTERFACCE": "FORGE_FLEET MANAGEMENT - INTERFACCE",
  "SISTEMA FEV (CONTI FEV)": "SENTINEL_SISTEMA FEV (CONTI FEV)",
  "LLOI - FLEET MIR": "QUANTUM_LLOI - FLEET MIR",
  "SISTEMA CONTABILE SAP BUSITALIA CAMPANIA": "SISTEMA CONTABILE SAP ROADRAIL CAMPANIA",
  "REM-ESB (IF-PIC) WSF": "QUANTUM_REM-ESB (IF-PIC) WSF",
  "FREG2": "FORGE_FREG2",
  "PDP ORARIO PIC2PDP": "HORIZON ORARIO PIC2PDP",
  "PDP ORARIO DIFFUSIONE ORARIO": "KRONOS ORARIO DIFFUSIONE ORARIO",
  "SISTEMA CONTABILE SAP GRANDI STAZIONI PRECONFIGURATO GAIA (FI/CONTABILITA' AFC)": "VECTOR_SISTEMA CONTABILE SAP GRANDI STAZIONI PRECONFIGURATO GAIA (FI/CONTABILITA' AFC)",
  "PDP - IMC IMPIANTI MANUTENZIONE CORRENTE PDP - IMC FRECCE": "PRISM - IMC IMPIANTI MANUTENZIONE CORRENTE PDP - IMC FRECCE",
  "PDP-COMPOSIZIONE TRENO PDP COMPOSIZIONE TRENO PASSEGGERI": "CIPHER_PDP-COMPOSIZIONE TRENO PDP COMPOSIZIONE TRENO PASSEGGERI",
  "SUPER BI": "ORION_SUPER BI",
  "SUPER2016": "QUANTUM_SUPER2016",
  "CRM TI PASSEGGERI - RTD PRECISION": "PRISM_CRM TI PASSEGGERI - RTD PRECISION",
  "SAP YARD MERCITALIA": "QUANTUM_SAP YARD MERCITALIA",
  "SISTEMA CONTABILE SAP ATAF": "NOVA_SISTEMA CONTABILE SAP ATAF",
  "NORMATIVA TI": "APEX_NORMATIVA TI",
  "PDP - IMC IMPIANTI MANUTENZIONE CORRENTE PDP - IMC REGIONALE": "SENTINEL - IMC IMPIANTI MANUTENZIONE CORRENTE PDP - IMC REGIONALE",
  "BIT": "ZENITH_BIT",
  "BO TBS": "SPECTRA_BO TBS",
  "INFOPUSH": "SENTINEL_INFOPUSH",
  "PKI": "HELIOS_PKI",
  "RIVEC": "NOVA_RIVEC",
  "HSM PER PVT": "AURA_HSM PER PVT",
  "EPASS INFORMATION HUB": "VECTOR_EPASS INFORMATION HUB",
  "PST": "PRISM_PST",
  "PDP STATO ROTABILE PDP SEGNALAZIONI": "POLARIS STATO ROTABILE PDP SEGNALAZIONI",
  "SISTEMA CONTABILE FS FONDAZIONE": "ATLAS_SISTEMA CONTABILE FS FONDAZIONE",
  "VT CARGO": "ATLAS_VT CARGO",
  "MBS": "APEX_MBS",
  "HCH (HARPA CONNECTION HSM)": "NEXUS_HCH (HARPA CONNECTION HSM)",
  "CRM TI PASSEGGERI - RECLAMI,CALL CENTER,IRIDE CRM RECLAMI-FURTI-CONCILIAZIONI-RDA": "ORION_CRM TI PASSEGGERI - RECLAMI,CALL CENTER,IRIDE CRM RECLAMI-FURTI-CONCILIAZIONI-RDA",
  "TELEDIAGNOSTICA E405": "AURA_TELEDIAGNOSTICA E405",
  "FLEET MANAGEMENT - INTERFACCE FLEET MANAGEMENT IVU CONTROLLER": "ZENITH_FLEET MANAGEMENT - INTERFACCE FLEET MANAGEMENT IVU CONTROLLER",
  "CRM TI PASSEGGERI - RECLAMI,CALL CENTER,IRIDE CRM INFOMOBILITA'": "APEX_CRM TI PASSEGGERI - RECLAMI,CALL CENTER,IRIDE CRM INFOMOBILITA'",
  "MONITORAGGIO SIGMA": "AURA_MONITORAGGIO SIGMA",
  "WEBFORM (ITINERE)": "ECHO_WEBFORM (ITINERE)",
  "CDVP 2.0 CDVP 2.0 - SAP PO": "VERTEX_CDVP 2.0 CDVP 2.0 - SAP PO",
  "IDV-RTV IDV": "KRYPTON_IDV-RTV IDV",
  "CREW MANAGEMENT - INTERFACCE CREW MANAGEMENT IVUTOMAC": "NOVA_CREW MANAGEMENT - INTERFACCE CREW MANAGEMENT IVUTOMAC",
  "CCSC BACK OFFICE CALYPSO": "SPECTRA_CCSC BACK OFFICE CALYPSO",
  "SUPER": "SENTINEL_SUPER",
  "SUPER SUPER 59": "SYNAPSE_SUPER SUPER 59",
  "VESTE": "NEXUS_VESTE",
  "SUPER TRENORD": "CIPHER_SUPER TRENORD",
  "PORTALE ISCRIZIONE SECURITY FS": "SPECTRA_PORTALE ISCRIZIONE SECURITY FS",
  "CDVP 2.0 TIMOTI2": "ORION_CDVP 2.0 TIMOTI2",
  "DATA ARCHIVING TRENITALIA LIVE ARCHIVING TRENITALIA": "DATA ARCHIVING VELOCERAIL LIVE ARCHIVING VELOCERAIL",
  "TBS BW TBS-REPORTING": "VECTOR_TBS BW TBS-REPORTING",
  "SITO SERVIZI PER ARRIVI E PARTENZE MALPENSA": "HORIZON_SITO SERVIZI PER ARRIVI E PARTENZE MALPENSA",
  "SIREV - FTP": "HYPERION_SIREV - FTP",
  "DATA ARCHIVING TRENITALIA DECOMMISSIONING TRENITALIA": "DATA ARCHIVING VELOCERAIL DECOMMISSIONING VELOCERAIL",
  "INFOBOARD MULTICOMPANY": "ATLAS_INFOBOARD MULTICOMPANY",
  "TBS - DOGANE FIRMA DIGITALE EDAS": "APEX_TBS - DOGANE FIRMA DIGITALE EDAS",
  "SGI NET": "HYPERION_SGI NET",
  "TBS BW TBS-P&C": "KRYPTON_TBS BW TBS-P&C",
  "INFOTREN INFOTREN MODULO": "BEACON_INFOTREN INFOTREN MODULO",
  "DIGITAL SIGNATURE SCENARIO": "SENTINEL_DIGITAL SIGNATURE SCENARIO",
  "SCCM": "PULSE_SCCM",
  "SINF": "CORE_SINF",
  "GESTIONE WAN FS PARK TIAKY": "GESTIONE WAN FS PARK HYPERION",
  "GESTIONE WAN ITALFERR TIAKY": "GESTIONE WAN TRANSRAIL HYPERION",
  "PIC-SI": "ZENITH_PIC-SI",
  "SAP SBU ALTRI SERVIZI - FERSERVIZI": "ORION_SAP SBU ALTRI SERVIZI - FERSERVIZI",
  "RUN - RISORSE UMANE NETWORK RUN - ENTERPRISE LEARNING SOLUTION": "NOVA_RUN - RISORSE UMANE NETWORK RUN - ENTERPRISE LEARNING SOLUTION",
  "BW RUN BW RUN (RISORSE UMANE)": "ECHO_BW RUN BW RUN (RISORSE UMANE)",
  "RUN - RISORSE UMANE NETWORK RUN-TM": "CIPHER_RUN - RISORSE UMANE NETWORK RUN-TM",
  "WORKFLOW INTERCOMPANY 2.0": "ORION_WORKFLOW INTERCOMPANY 2.0",
  "SAP SBU ALTRI SERVIZI - FS TECH": "FORGE_SAP SBU ALTRI SERVIZI - FS TECH",
  "RUN - RISORSE UMANE NETWORK RUN PA": "SPECTRA_RUN - RISORSE UMANE NETWORK RUN PA",
  "RUN - RISORSE UMANE NETWORK RUN-PD": "VORTEX_RUN - RISORSE UMANE NETWORK RUN-PD",
  "RUN - RISORSE UMANE NETWORK RUN SERVIZI TRASVERSALI": "BEACON_RUN - RISORSE UMANE NETWORK RUN SERVIZI TRASVERSALI",
  "SAP MDG BAM": "FORGE_SAP MDG BAM",
  "BW DI GRUPPO": "HORIZON_BW DI GRUPPO",
  "RUN - RISORSE UMANE NETWORK BANCA DATI TRASFERIMENTI": "ECHO_RUN - RISORSE UMANE NETWORK BANCA DATI TRASFERIMENTI",
  "RUN - RISORSE UMANE NETWORK RUN-PAYROLL": "KRYPTON_RUN - RISORSE UMANE NETWORK RUN-PAYROLL",
  "SAP SBU ALTRI SERVIZI FS INTERNATIONAL": "CIPHER_SAP SBU ALTRI SERVIZI FS INTERNATIONAL",
  "RUN - RISORSE UMANE NETWORK RUN-ORGANIZZAZIONE": "SENTINEL_RUN - RISORSE UMANE NETWORK RUN-ORGANIZZAZIONE",
  "RUN - RISORSE UMANE NETWORK RUN-INTERFACCE": "KRONOS_RUN - RISORSE UMANE NETWORK RUN-INTERFACCE",
  "BW FS HOLDING": "PRISM_BW FS HOLDING",
  "SAP SBU ALTRI SERVIZI - SISTEMI URBANI": "OMNIA_SAP SBU ALTRI SERVIZI - SISTEMI URBANI",
  "RUN - RISORSE UMANE NETWORK AMMINISTRAZIONE DIRIGENTI": "APEX_RUN - RISORSE UMANE NETWORK AMMINISTRAZIONE DIRIGENTI",
  "WORKFLOW INTERCOMPANY PAH - PORTALE APPLICAZIONI": "PRISM_WORKFLOW INTERCOMPANY PAH - PORTALE APPLICAZIONI",
  "SAP SBU MERCI PMBS-LOG": "CIPHER_SAP SBU MERCI PMBS-LOG",
  "BPC ON TBS": "NEXUS_BPC ON TBS",
  "RUN - RISORSE UMANE NETWORK TALENT CV ONLINE": "TITAN_RUN - RISORSE UMANE NETWORK TALENT CV ONLINE",
  "APP LIBRO DI BORDO": "APP CORE_LIBRO DI BORDO",
  "RUN - RISORSE UMANE NETWORK RUN-PORTALE RJE": "HYPERION_RUN - RISORSE UMANE NETWORK RUN-PORTALE RJE",
  "SAP SBU ALTRI SERVIZI - VIM": "AEGIS_SAP SBU ALTRI SERVIZI - VIM",
  "SAP SBU ALTRI SERVIZI - FONDAZIONE": "APEX_SAP SBU ALTRI SERVIZI - FONDAZIONE",
  "SAP MDG MDG APPL": "SPECTRA_SAP MDG MDG APPL",
  "MUIF MUIF CORE": "KRONOS_APP KRONOS_APP CORE",
  "E-PIR": "KRYPTON_E-PIR",
  "TSCM-FA": "TITAN_TSCM-FA",
  "MRC": "QUANTUM_MRC",
  "MUIF": "KRONOS_APP",
  "IOT INFRASTRUTTURA FERROVIARIA": "ORION_IOT INFRASTRUTTURA FERROVIARIA",
  "RFI LCM": "INFRARETE LCM",
  "GESTIONE WAN MERCITALIA LOGISTICS TIAKY": "GESTIONE WAN MERCITALIA LOGISTICS HYPERION",
  "GESTIONE WAN MIST TIAKY": "GESTIONE WAN MIST HYPERION",
  "GESTIONE WAN FSE TIAKY": "GESTIONE WAN MEDITERRANEA HYPERION",
  "ILSA PROXY": "VERTEX_ILSA PROXY",
  "NCD": "KRONOS_NCD",
  "IDV-RTV": "NOVA_IDV-RTV",
  "DONET - GESTIONE CIRCOLARI": "AEGIS_DONET - GESTIONE CIRCOLARI",
  "LEO (NEW GOT)": "KRONOS_LEO (NEW GOT)",
  "GESTIONE WAN FSH TIAKY": "GESTIONE WAN FSH HYPERION",
  "SIMS - FLAGSHIP DEL MOST": "ECHO_SIMS - FLAGSHIP DEL MOST",
  "BUSINESS APPLICATION IGNOTA": "BUSINESS APPLICATION RISERVATA",
  "CENTRALIZZAZIONE XATLAS": "HORIZON_CENTRALIZZAZIONE XATLAS",
  "AVL MOBILE SOLUTION": "NOVA_AVL MOBILE SOLUTION",
  "MOBILE CONNECTION MANAGEMENT (MCM)": "BEACON_MOBILE CONNECTION MANAGEMENT (MCM)",
  "MANUTENZIONE SALE (UNITÀ DI CRISI, CIRCOLAZIONE, SALA AD E SALA RUIU)": "OMNIA_MANUTENZIONE SALE (UNITÀ DI CRISI, CIRCOLAZIONE, SALA AD E SALA RUIU)",
  "PROOFPOINT SECURE EMAIL RELAY": "APEX_PROOFPOINT SECURE EMAIL RELAY",
  "SALA OPERATIVA INFRASTRUTTURA": "NOVA_SALA OPERATIVA INFRASTRUTTURA",
  "PROTEZIONE POSTA ELETTRONICA": "POLARIS_PROTEZIONE POSTA ELETTRONICA",
  "GESTIONE LAN FERC": "FORGE_GESTIONE LAN FERC",
  "SYMANTEC SEP": "AEGIS_SYMANTEC SEP",
  "GESTIONE LICENZEMS": "CIPHER_GESTIONE LICENZEMS",
  "SAP B - ONE": "HELIOS_SAP B - ONE",
  "SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) FS PARK": "FORGE_SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) FS PARK",
  "PICO5": "POLARIS-5",
  "SIV – SISTEMA INTEGRATO DI VALUTAZIONE": "KRYPTON_SIV – SISTEMA INTEGRATO DI VALUTAZIONE",
  "PICO6": "POLARIS-6",
  "RAVEL - GESTIONE CONTENUTI MULTIMEDIALI DI BORDO": "SPECTRA_RAVEL - GESTIONE CONTENUTI MULTIMEDIALI DI BORDO",
  "INFOBOARD EPM": "PULSE_INFOBOARD EPM",
  "INFOBOARD RAI": "TITAN_INFOBOARD RAI",
  "MAXIMO": "VECTOR_MAXIMO",
  "BUTP325": "CORE_BUTP325",
  "IAM": "POLARIS_IAM",
  "CRM SALESFORCE": "AEGIS_CRM SALESFORCE",
  "ROMAN TDP - GTDP": "PULSE_ROMAN TDP - GTDP",
  "ASTER QO": "FORGE_ASTER QO",
  "PDP-COMPOSIZIONE TRENO PDP COMPOSIZIONE TRENO REGIONALE": "KRYPTON_PDP-COMPOSIZIONE TRENO PDP COMPOSIZIONE TRENO REGIONALE",
  "ESGEO - REPORTING SOSTENIBILITÀ": "HYPERION_ESGEO - REPORTING SOSTENIBILITÀ",
  "SERVIZIO DI MONITORAGGIO DYNATRACE PER FST": "VECTOR_SERVIZIO DI MONITORAGGIO DYNATRACE PER FST",
  "SAP DATASPHERE SHARED SERVICES - CONTINUOUS AUDITING": "AURA_SAP DATASPHERE SHARED SERVICES - CONTINUOUS AUDITING",
  "P2P CRUSCOTTO DI MONITORAGGIO GRUPPO FS": "VERTEX_P2P CRUSCOTTO DI MONITORAGGIO GRUPPO FS",
  "P2P PORTALE ACQUISTI GRUPPO FS": "VERTEX_P2P PORTALE ACQUISTI GRUPPO FS",
  "IN.RETE MANUTENZIONE IN.RETE2000 MANUTENZIONE": "AEGIS_IN.RETE MANUTENZIONE IN.RETE2000 MANUTENZIONE",
  "IN.RETE AFC CICLO ATTIVO E PASSIVO": "SYNAPSE_IN.RETE AFC CICLO ATTIVO E PASSIVO",
  "DRM RFI": "DRM INFRARETE",
  "SEM SVI": "ZENITH_SEM SVI",
  "GESTIONE LAN RFI": "GESTIONE LAN INFRARETE",
  "LOQUENDOWS": "HELIOS_LOQUENDOWS",
  "RILEVA E MIGLIORA": "ATLAS_RILEVA E MIGLIORA",
  "MOBILE APP MYWE": "SENTINEL_MOBILE APP MYWE",
  "SDA_ONLINE": "KRONOS_SDA_ONLINE",
  "DBLWEB FSI": "SYNAPSE_DBLWEB FSI",
  "CODIV INTRANET": "PRISM_CODIV INTRANET",
  "VIAGGIAFSE": "SPECTRA_VIAGGIAFSE",
  "PIATTAFORMA GIS / ESRI LINEE DISMESSE": "NOVA_PIATTAFORMA GIS / ESRI LINEE DISMESSE",
  "SAI - SISTEMA AUTORIZZAZIONE INVESTIMENTI": "HORIZON_SAI - SISTEMA AUTORIZZAZIONE INVESTIMENTI",
  "PORTALE HYBRIS": "POLARIS_PORTALE HYBRIS",
  "CONTENT SERVER RUN": "TITAN_CONTENT SERVER RUN",
  "SUITE EPM - HFM": "NOVA_SUITE EPM - HFM",
  "GESTIONE LAN FSE": "GESTIONE LAN MEDITERRANEA",
  "SISTEMA SAP CENTOSTAZIONI HOSTING": "VECTOR_SISTEMA SAP CENTOSTAZIONI HOSTING",
  "CDVP": "ATLAS_CDVP",
  "TIMOTI (REGIONALE)": "FORGE_TIMOTI (REGIONALE)",
  "SISTEMA CONTABILE SAP GRANDI STAZIONI PRECONFIGURATO GAIA (PM/MANUTENZIONE)": "OMNIA_SISTEMA CONTABILE SAP GRANDI STAZIONI PRECONFIGURATO GAIA (PM/MANUTENZIONE)",
  "SISTEMA CONTABILE SAP GRANDI STAZIONI PRECONFIGURATO GAIA (SD/VENDITE)": "OMNIA_SISTEMA CONTABILE SAP GRANDI STAZIONI PRECONFIGURATO GAIA (SD/VENDITE)",
  "W_SEC-EXT": "QUANTUM_W_SEC-EXT",
  "ISMS": "FORGE_ISMS",
  "SISTEMA CONTABILE MERCITALIA SHUNTING": "KRYPTON_SISTEMA CONTABILE MERCITALIA SHUNTING",
  "PANDORA": "APEX_PANDORA",
  "MCUBO": "SENTINEL_MCUBO",
  "SIR CARGO MASTER": "SENTINEL_SIR CARGO MASTER",
  "AS/400": "NEXUS_AS/400",
  "PICO_HELLENIC": "POLARIS_HELLENIC",
  "AMIANTO": "CIPHER_AMIANTO",
  "RDA AUTOMATIZZATA E QUALIFICA FORNITORI": "ECHO_RDA AUTOMATIZZATA E QUALIFICA FORNITORI",
  "RILEVAZIONE PRESENZE E CONTROLLO ACCESSI (HONEYWELL)": "SENTINEL_RILEVAZIONE PRESENZE E CONTROLLO ACCESSI (HONEYWELL)",
  "DIAGNOSI PANTOGRAFI": "SPECTRA_DIAGNOSI PANTOGRAFI",
  "FIM RFI": "FIM INFRARETE",
  "RINF": "ZENITH_RINF",
  "IEC CENTRALE": "KRONOS_IEC CENTRALE",
  "IRIDE PER BDP": "ATLAS_IRIDE PER BDP",
  "FMP": "NEXUS_FMP",
  "REPOSITORY PROTON RFI": "REPOSITORY PROTON INFRARETE",
  "OSSERVATORIO DI MERCATO": "KRYPTON_OSSERVATORIO DI MERCATO",
  "GESTIONE APN RFI": "GESTIONE APN INFRARETE",
  "DRUMS PLANNING & CONTROL": "ORION_DRUMS PLANNING & CONTROL",
  "SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) MERCITALIA": "NOVA_SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) MERCITALIA",
  "SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) MERCITALIA LOGISTICS": "ZENITH_SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) MERCITALIA LOGISTICS",
  "PDP STATO ROTABILE PDP ANAGRAFICA MATERIALI": "SPECTRA STATO ROTABILE PDP ANAGRAFICA MATERIALI",
  "PIATTAFORMA TLN INTERFACCE SISTEMI LEGACY": "ECHO_PIATTAFORMA TLN INTERFACCE SISTEMI LEGACY",
  "REM-ESB (IF-PIC) IF-PIC": "QUANTUM_REM-ESB (IF-PIC) IF-PIC",
  "CCSC TPER": "NEXUS_CCSC TPER",
  "CONTR-2000 CERT": "ATLAS_CONTR-2000 CERT",
  "FAULT ASTER PPC": "OMNIA_FAULT ASTER PPC",
  "MDM DOCUMENTALE": "SYNAPSE_MDM DOCUMENTALE",
  "TI-STS": "VECTOR_TI-STS",
  "CRM TI PASSEGGERI - LOYALTY AUC:35 CRM LOYALTY & ANAGRAFICA UNICA B2C": "BEACON_CRM TI PASSEGGERI - LOYALTY AUC:35 CRM LOYALTY & ANAGRAFICA UNICA B2C",
  "CRM TI PASSEGGERI - LOYALTY AUC:35 CRM LOYALTY & ANAGRAFICA UNICA B2B": "VECTOR_CRM TI PASSEGGERI - LOYALTY AUC:35 CRM LOYALTY & ANAGRAFICA UNICA B2B",
  "CCSC CCSC MODULO": "HORIZON_CCSC CCSC MODULO",
  "CCSC INSTANT ISSUING TPL": "PRISM_CCSC INSTANT ISSUING TPL",
  "IDV-RTV RTV": "HYPERION_IDV-RTV RTV",
  "SISTEMA CONTABILE SAP FS SISTEMI URBANI": "KRYPTON_SISTEMA CONTABILE SAP FS SISTEMI URBANI",
  "SAP SBU ALTRI SERVIZI FS": "BEACON_SAP SBU ALTRI SERVIZI FS",
  "SAP SBU ALTRI SERVIZI TESACC": "VECTOR_SAP SBU ALTRI SERVIZI TESACC",
  "MONITORAGGIO PONTI": "PULSE_MONITORAGGIO PONTI",
  "BW RUN BW RUN (PIANIFICAZIONE DEL PERSONALE)": "ORION_BW RUN BW RUN (PIANIFICAZIONE DEL PERSONALE)",
  "SAP SBU MERCI PMBS-DOGANE": "OMNIA_SAP SBU MERCI PMBS-DOGANE",
  "SAP SBU MERCI PMBS-AFC": "SPECTRA_SAP SBU MERCI PMBS-AFC",
  "PO FSH": "AURA_PO FSH",
  "SAP SBU MERCI PMBS-BPC": "OMNIA_SAP SBU MERCI PMBS-BPC",
  "SAP SBU MERCI PMBS-MNT": "VORTEX_SAP SBU MERCI PMBS-MNT",
  "CDVP 2.0 CDVP 2.0 - SAP BO": "HORIZON_CDVP 2.0 CDVP 2.0 - SAP BO",
  "GESTIONE WAN DCPA TIAKY": "GESTIONE WAN DCPA HYPERION",
  "SONDA MPLS-INTERNET": "CIPHER_SONDA MPLS-INTERNET",
  "GESTIONE WAN FERSERV TIAKY": "GESTIONE WAN FERSERV HYPERION",
  "AUTODESK FS PARK": "VORTEX_AUTODESK FS PARK",
  "SAP DATASPHERE SHARED SERVICES - CONTINUOUS AUDITING": "SPECTRA_SAP DATASPHERE SHARED SERVICES - CONTINUOUS AUDITING",
  "ELOFICASH": "CORE_ELOFICASH",
  "RFI STAZIONI SISMICHE": "INFRARETE STAZIONI SISMICHE",
  "IN.RETE MANUTENZIONE": "AURA_IN.RETE MANUTENZIONE",
  "GESTIONE WAN FSTECHNOLOGY TIAKY": "GESTIONE WAN INNOVATECH HYPERION",
  "GESTIONE WAN MIR TIAKY": "GESTIONE WAN MIR HYPERION",
  "PICO_DB_STORICO": "POLARIS_DB_ARCHIVE",
  "REPLICA DOMAIN CONTROLLER PICO": "REPLICA DOMAIN CONTROLLER POLARIS",
  "DOMINIO ESTERNI": "HORIZON_DOMINIO ESTERNI",
  "IN.RETE MANUTENZIONE IN.RETE2000 MANUTENZIONE FABBRICATI": "ATLAS_IN.RETE MANUTENZIONE IN.RETE2000 MANUTENZIONE FABBRICATI",
  "ESERCIZIO DEI SISTEMI DI VIDEOSORVEGLIANZA RFI": "ESERCIZIO DEI SISTEMI DI VIDEOSORVEGLIANZA INFRARETE",
  "NUANCE VOCALIZER": "HYPERION_NUANCE VOCALIZER",
  "BW-FERSERVIZI (GEST.IMMOBILIARE)": "AEGIS_BW-FERSERVIZI (GEST.IMMOBILIARE)",
  "DIGITAL SIGNAGE": "FORGE_DIGITAL SIGNAGE",
  "SAP TIE CEMAT": "BEACON_SAP TIE CEMAT",
  "CRUSCOTTI DIREZIONALI": "PULSE_CRUSCOTTI DIREZIONALI",
  "SPTL": "POLARIS_SPTL",
  "INFOCARGO": "HYPERION_INFOCARGO",
  "INFOCAD CERT": "CORE_INFOCAD CERT",
  "SHAREPOINT NEW RFI": "SHAREPOINT NEW INFRARETE",
  "PEC PER PROTON": "HELIOS_PEC PER PROTON",
  "SISTEMA CONTABILE NUGO": "CIPHER_SISTEMA CONTABILE NUGO",
  "SAP SBU GOMMA": "VERTEX_SAP SBU GOMMA",
  "PDP FT FT REGIONALE": "KRYPTON FT FT REGIONALE",
  "TBS TBS - PI": "CIPHER_TBS TBS - PI",
  "SIREV 2.0": "SPECTRA_SIREV 2.0",
  "SUPER SUPER2010": "SENTINEL_SUPER SUPER2010",
  "DMMS PI": "OMNIA_DMMS PI",
  "WEB PROTECTION": "APEX_WEB PROTECTION",
  "HOUSING SISTEMI BOMBARDIER": "ORION_HOUSING SISTEMI BOMBARDIER",
  "GESTIONE WAN MERCITALIA INTERMODAL TIAKY": "GESTIONE WAN MERCITALIA INTERMODAL HYPERION",
  "REALIZZAZIONE CONNETTIVITÀ DI CAMPUS E LAN PER PIOVE DI SACCO": "PULSE_REALIZZAZIONE CONNETTIVITÀ DI CAMPUS E LAN PER PIOVE DI SACCO",
  "COMMON PLATFORM FILENET": "HYPERION_COMMON PLATFORM FILENET",
  "TBS FILENET": "VORTEX_TBS FILENET",
  "GESTIONE LAN TTI": "TITAN_GESTIONE LAN TTI",
  "DCPXLS": "KRYPTON_DCPXLS",
  "GESTIONE E PUBBLICAZIONE POSTI AUTO": "SENTINEL_GESTIONE E PUBBLICAZIONE POSTI AUTO",
  "SGAM": "VERTEX_SGAM",
  "PDP STATO ROTABILE PDP MANUTENZIONE ROTABILE": "VECTOR STATO ROTABILE PDP MANUTENZIONE ROTABILE",
  "IN.RETE AFC CONTROLLO": "PULSE_IN.RETE AFC CONTROLLO",
  "SOLUTION MANAGER ON HANA": "HORIZON_SOLUTION MANAGER ON HANA",
  "BI AFC BW-SAFETY": "POLARIS_BI AFC BW-SAFETY",
  "SISTEMI DI BUDGET (ECONOMICO E PATRIMONIALE) BUDGET ECONOMICO": "HELIOS_SISTEMI DI BUDGET (ECONOMICO E PATRIMONIALE) BUDGET ECONOMICO",
  "LIS SANITÀ": "HORIZON_LIS SANITÀ",
  "RIACE COPIA DB": "CIPHER_RIACE COPIA DB",
  "ATLANTIDEDS8 - GESTIONE RIFIUTI": "SPECTRA_ATLANTIDEDS8 - GESTIONE RIFIUTI",
  "CATASTO-WMS REFLECTOR": "AEGIS_CATASTO-WMS REFLECTOR",
  "PCE - MISURATORE VIRTUALE": "NOVA_PCE - MISURATORE VIRTUALE",
  "VIRTUALIZZATORE DATI": "HELIOS_VIRTUALIZZATORE DATI",
  "SOLUZIONE SICUREZZA PER FW E-O - FSTECH": "SOLUZIONE SICUREZZA PER FW E-O - INNOVATECH",
  "PDP FT PREDICI": "PRISM FT PREDICI",
  "CONTR-2000": "APEX_CONTR-2000",
  "TSCM-APO": "OMNIA_TSCM-APO",
  "TIMBRATURE": "NEXUS_TIMBRATURE",
  "CCSC CARTA FRECCIA ROSSA": "HELIOS_CCSC CARTA FRECCIA ROSSA",
  "TBS TBS FILENET": "HORIZON_TBS TBS FILENET",
  "FILESERVERPROTON": "HYPERION_FILESERVERPROTON",
  "SISTEMA CONTABILE SAP BUSITALIA RAIL SERVICE": "SISTEMA CONTABILE SAP ROADRAIL RAIL SERVICE",
  "WORKFLOW INTERCOMPANY PI WORKFLOW INTERCOMPANY": "AEGIS_WORKFLOW INTERCOMPANY PI WORKFLOW INTERCOMPANY",
  "SAP MDG BSF NEW": "AURA_SAP MDG BSF NEW",
  "BW RUN BW RUN - COSTO STANDARD DEL LAVORO": "OMNIA_BW RUN BW RUN - COSTO STANDARD DEL LAVORO",
  "AULE VIRTUALI": "ATLAS_AULE VIRTUALI",
  "DIAGNOSTICA TC": "VERTEX_DIAGNOSTICA TC",
  "PORTALESANITA'-RFI": "PORTALESANITA'-INFRARETE",
  "PRENOTAZIONE PARCHEGGI TRENITALIA (PICO)": "PRENOTAZIONE PARCHEGGI VELOCERAIL (POLARIS)",
  "COSMO_OLD": "BEACON_COSMO_OLD",
  "SECURITY VIRTUAL DESKTOP VDI": "KRYPTON_SECURITY VIRTUAL DESKTOP VDI",
  "EUROSAP CO.AN. PS/CO": "SYNAPSE_EUROSAP CO.AN. PS/CO",
  "SAC SHARED SERVICES - CONTINUOUS AUDITING": "FORGE_SAC SHARED SERVICES - CONTINUOUS AUDITING",
  "BI AFC BPC RFI": "BI AFC BPC INFRARETE",
  "IN.RETE AFC ASSET": "VECTOR_IN.RETE AFC ASSET",
  "CERTIFICATION AUTORITY FSE": "CERTIFICATION AUTORITY MEDITERRANEA",
  "SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) CENTOSTAZIONI": "PRISM_SERVIZI DI RETE DI BASE (DHCP, DNS, ECC) CENTOSTAZIONI",
  "PIATTAFORMA INTEGRAZIONE DIAGNOSTICA RTB": "OMNIA_PIATTAFORMA INTEGRAZIONE DIAGNOSTICA RTB",
  "INFOCAD": "POLARIS_INFOCAD",
  "SIREV 2.0 SIREV 2.0 SAP BO": "HORIZON_SIREV 2.0 SIREV 2.0 SAP BO",
  "PROTEZIONE NAVIGAZIONE CLIENT": "HYPERION_PROTEZIONE NAVIGAZIONE CLIENT",
  "PICO1": "POLARIS-1",
  "TIME WEB": "POLARIS_TIME WEB",
  "SERVIZIO INTERNET FSTECH DATACENTER TIAKY": "SERVIZIO INTERNET INNOVATECH DATACENTER HYPERION",
  "ARCHIBUS CLOUD": "PULSE_ARCHIBUS CLOUD",
  "SAP MDG": "FORGE_SAP MDG",
  "IBEX": "PULSE_IBEX",
  "IN.RETE AFC INRETE_NEWGL": "POLARIS_IN.RETE AFC INRETE_NEWGL",
  "IN.RETE AFC CONTABILITA' E FINANZA": "AEGIS_IN.RETE AFC CONTABILITA' E FINANZA",
  "IN.RETE MANUTENZIONE IN.RETE2000 SICUREZZA LAVORATORI": "NEXUS_IN.RETE MANUTENZIONE IN.RETE2000 SICUREZZA LAVORATORI",
  "GESTIONE SERVIZI SAP BTP": "CORE_GESTIONE SERVIZI SAP BTP",
  "HOSTING KPI FSE": "HOSTING KPI MEDITERRANEA",
  "FTP": "CORE_FTP",
  "DOMAIN CONTROLLER EX MANDARINO": "QUANTUM_DOMAIN CONTROLLER EX MANDARINO",
  "GESTIONE WAN SU TIAKY": "GESTIONE WAN SU HYPERION",
  "MOBILE DEVICE MANAGEMENT DI GRUPPO -MFA": "ZENITH_MOBILE DEVICE MANAGEMENT DI GRUPPO -MFA",
  "PICO2": "POLARIS-2",
  "IN.RETE MANUTENZIONE PLANIMETRIE": "ZENITH_IN.RETE MANUTENZIONE PLANIMETRIE",
  "SMA-DOTE": "PULSE_SMA-DOTE",
  "IVR HR": "AEGIS_IVR HR",
  "RADIUS BUSITALIA": "RADIUS ROADRAIL",
  "CRM IRIDE": "CORE_CRM IRIDE",
  "DISCLOSURE MANAGEMENT AZURE": "QUANTUM_DISCLOSURE MANAGEMENT AZURE",
  "GESTIONE APPARATI SOC": "APEX_GESTIONE APPARATI SOC",
  "DISCLOSURE MANAGEMENT RFI": "DISCLOSURE MANAGEMENT INFRARETE",
  "NETWORKING E APPARATI GESTIONE LAN RFI": "NETWORKING E APPARATI GESTIONE LAN INFRARETE",
  "CERTIFICATION AUTORITY INTERNA (PKI)": "SPECTRA_CERTIFICATION AUTORITY INTERNA (PKI)",
  "SERVICE DESK EVOLUTO": "SERVICE GATEWAY EVOLUTO",
  "NB3": "CORE_NB3",
  "PIATTAFORMA NDR": "AEGIS_PIATTAFORMA NDR",
  "DASHBOARD RFC": "ORION_DASHBOARD RFC",
  "GESTIONE UPS PARCHEGGI": "AURA_GESTIONE UPS PARCHEGGI",
  "SAP SBU MERCI": "AURA_SAP SBU MERCI",
  "NETWORKING E APPARATI DISTRIBUITI SWITCH RETE ROSSA": "PULSE_NETWORKING E APPARATI DISTRIBUITI SWITCH RETE ROSSA",
  "SISTEMI DI BUDGET (ECONOMICO E PATRIMONIALE) BUDGET PATRIMONIALE": "VORTEX_SISTEMI DI BUDGET (ECONOMICO E PATRIMONIALE) BUDGET PATRIMONIALE",
  "DMMS FILE GATEWAY DOWNLOAD": "POLARIS_DMMS FILE GATEWAY DOWNLOAD",
  "SISTEMA CONTABILE MERCITALIA LOGISTICS": "HORIZON_SISTEMA CONTABILE MERCITALIA LOGISTICS",
  "CATASTO - GOOGLE EARTH ENTERPRISE": "ZENITH_CATASTO - GOOGLE EARTH ENTERPRISE",
  "GESTIONE WAN BU – TIAKY": "GESTIONE WAN BU – HYPERION",
  "MOBILE DEVICE MANAGEMENT DI GRUPPO -SCCM": "ECHO_MOBILE DEVICE MANAGEMENT DI GRUPPO -SCCM",
  "AUTODESK": "PULSE_AUTODESK",
  "PICO7": "POLARIS-7",
  "SUPPORTO PIATTAFORMA SIAS": "TITAN_SUPPORTO PIATTAFORMA SIAS",
  "CLOUD O365": "NOVA_CLOUD O365",
  "REI": "HYPERION_REI",
  "PROTEZIONE NAVIGAZIONE SERVER": "NOVA_PROTEZIONE NAVIGAZIONE SERVER",
  "AUTOMATIZZAZIONE LDV TRAMITE OPEN AI": "KRONOS_AUTOMATIZZAZIONE LDV TRAMITE OPEN AI",
  "GESTIONE CED AZURE VMWARE SOLUTION FSI (AVS)": "OMNIA_GESTIONE CED AZURE VMWARE SOLUTION FSI (AVS)",
  "REPLICA DOMAIN CONTROLLER IVU": "PRISM_REPLICA DOMAIN CONTROLLER IVU",
  "SECURITY ASSSTMENT (VA)": "PULSE_SECURITY ASSSTMENT (VA)",
  "DIGITAL HUB": "PRISM_DIGITAL HUB",
  "SOLUZIONE CHECK POINT CLOUDGUARD PER AMBIENTI OCI": "SENTINEL_SOLUZIONE CHECK POINT CLOUDGUARD PER AMBIENTI OCI",
  "SERVIZIO CONDUZIONE TECNICA AS400": "CIPHER_SERVIZIO CONDUZIONE TECNICA AS400",
  "INFRASTRUTTURA CENTOSTAZIONI": "SPECTRA_INFRASTRUTTURA CENTOSTAZIONI",
  "SERVIZI SAAS GOOGLE MAPS": "NEXUS_SERVIZI SAAS GOOGLE MAPS",
  "ESGEO - SUPPLY CHAIN MANAGEMENT SOSTENIBILITA'": "SPECTRA_ESGEO - SUPPLY CHAIN MANAGEMENT SOSTENIBILITA'",
  "P2P PAPERLESS GRUPPO FS": "QUANTUM_P2P PAPERLESS GRUPPO FS",
  "APPARATI DI RETE DEL GRUPPO FS": "ORION_APPARATI DI RETE DEL GRUPPO FS",
  "NETWORKING E APPARATI": "ATLAS_NETWORKING E APPARATI",
  "DISCOVERY LAB": "NEXUS_DISCOVERY LAB",
  "DMMS - HANA ESERCIZIO": "VORTEX_DMMS - HANA ESERCIZIO",
  "HERMES": "CIPHER_HERMES",
  "ZERO DAY": "HELIOS_ZERO DAY",
  "DMMS- SAP IQ": "SYNAPSE_DMMS- SAP IQ",
  "TRENORD ECC CONSULTAZIONE": "AURA_TRENORD ECC CONSULTAZIONE",
  "TBS TBS PRC": "BEACON_TBS TBS PRC",
  "GESTIONE DOMINI INTERNET E CERTIFICATI SSL": "SENTINEL_GESTIONE DOMINI INTERNET E CERTIFICATI SSL",
  "NETWORK TAP": "CIPHER_NETWORK TAP",
  "P2P FABBISOGNI GRUPPO FS": "NEXUS_P2P FABBISOGNI GRUPPO FS",
  "SAP BTP - NUOVO PORTALE DELLA LOGISTICA": "ZENITH_SAP BTP - NUOVO PORTALE DELLA LOGISTICA",
  "SERVIZIO DEFENDER FSI": "PRISM_SERVIZIO DEFENDER FSI",
  "CLOUD SALESFORCE DI MERCITALIA": "BEACON_CLOUD SALESFORCE DI MERCITALIA",
  "MOBILE DEVICE MANAGEMENT DI GRUPPO -INTUNE": "QUANTUM_MOBILE DEVICE MANAGEMENT DI GRUPPO -INTUNE",
  "RECRUITMENT": "SENTINEL_RECRUITMENT",
  "F.C.A.": "ATLAS_F.C.A.",
  "DMMS - HANA INGENGERIA": "HELIOS_DMMS - HANA INGENGERIA",
  "TELEFONIA VOIP": "HYPERION_TELEFONIA VOIP",
  "GESTIONE USAT": "HELIOS_GESTIONE USAT",
  "ADB - ARCHIVIO DISEGNI APPARECCHI DI BINARIO": "PRISM_ADB - ARCHIVIO DISEGNI APPARECCHI DI BINARIO",
  "DIS": "APEX_DIS",
  "SAC - BUDGET INVESTIMENTI": "ECHO_SAC - BUDGET INVESTIMENTI",
  "SERVIZIO TS-WAY": "ATLAS_SERVIZIO TS-WAY",
  "PKI NEW": "SYNAPSE_PKI NEW",
  "EUROSAP LOGISTICA MM/SD": "CORE_EUROSAP LOGISTICA MM/SD",
  "SIRIO": "PRISM_SIRIO",
  "NUTANIX RFI (AREA MUIF)": "NUTANIX INFRARETE (AREA KRONOS_APP)",
  "MOBILE DEVICE MANAGEMENT TIT": "NEXUS_MOBILE DEVICE MANAGEMENT TIT",
  "INFRASTRUTTURA NOC TIAKY": "INFRASTRUTTURA NOC HYPERION",
  "POSTA FS ONLINE": "OMNIA_POSTA FS ONLINE",
  "SISTEMA IPERCONVERGENTE NUTANIX": "ECHO_SISTEMA IPERCONVERGENTE NUTANIX",
  "SAP BTP ANDAMENTI": "OMNIA_SAP BTP ANDAMENTI",
  "SAP CPI MERCITALIA": "HORIZON_SAP CPI MERCITALIA",
  "PICO": "POLARIS",
  "PIANIFICAZIONE ORGANICI CLOUD": "AURA_PIANIFICAZIONE ORGANICI CLOUD",
  "MODULO WAS PER QUALYS": "OMNIA_MODULO WAS PER QUALYS",
  "SERVIZIO DI CONTENT FILTERING PER SITI DI GRUPPO": "POLARIS_SERVIZIO DI CONTENT FILTERING PER SITI DI GRUPPO",
  "SERVICE NOW - GE.CO.": "ATLAS_SERVICE NOW - GE.CO.",
  "PIATTAFORMA RETI": "ZENITH_PIATTAFORMA RETI",
  "SERVICE NOW - CONDUZIONE PIATTAFORMA FST": "HELIOS_SERVICE NOW - CONDUZIONE PIATTAFORMA FST",
  "SERVIZIO INTERNET MERCITALIA LOGISTICS": "ZENITH_SERVIZIO INTERNET MERCITALIA LOGISTICS",
  "DEVOPS FSI": "HYPERION_DEVOPS FSI",
  "REGISTRO DEI BENI": "NEXUS_REGISTRO DEI BENI",
  "EUROSAP CO.GE. FI/HR MODULO AAF": "KRONOS_EUROSAP CO.GE. FI/HR MODULO AAF",
  "RESPONSYS": "AURA_RESPONSYS",
  "SALESFORCE CRM": "HORIZON_SALESFORCE CRM",
  "GEOCALL CLOUD": "POLARIS_GEOCALL CLOUD",
  "IN.RETE OFFICINE DI PRODUZIONE": "PRISM_IN.RETE OFFICINE DI PRODUZIONE",
  "ILMT TRENITALIA": "ILMT VELOCERAIL",
  "SERVIZIO GESTIONE CED AZURE FSI": "SENTINEL_SERVIZIO GESTIONE CED AZURE FSI",
  "WEB ANALYTICS FSH": "ATLAS_WEB ANALYTICS FSH",
  "MICROSTRATEGY CLOUD": "VORTEX_MICROSTRATEGY CLOUD",
  "ILMT RFI": "ILMT INFRARETE",
  "GESTIONE CED ORACLE CLOUD INFRASTRUCTURE FSI (OCI)0015982956": "QUANTUM_GESTIONE CED ORACLE CLOUD INFRASTRUCTURE FSI (OCI)0015982956",
  "RUN": "ZENITH_RUN",
  "PBCS MII": "SYNAPSE_PBCS MII",
  "PBCS MIL": "VORTEX_PBCS MIL",
  "T&T CLOUD (BTP)": "KRONOS_T&T CLOUD (BTP)",
  "QLIK I-MAN": "CORE_QLIK I-MAN",
  "SHAREPOINT ON LINE WE": "QUANTUM_SHAREPOINT ON LINE WE",
  "CLOUD ORCHESTRATOR SUITE EPM": "TITAN_CLOUD ORCHESTRATOR SUITE EPM",
  "SAP MBC-MULTI-BANK CONNECTIVITY": "ECHO_SAP MBC-MULTI-BANK CONNECTIVITY",
  "MOI": "ZENITH_MOI",
  "ARIBA CLOUD": "OMNIA_ARIBA CLOUD",
  "SOD - SEGREGATION OF DUTIES - RISE": "HORIZON_SOD - SEGREGATION OF DUTIES - RISE",
  "EPM_FERSERVIZI CLOUD": "CIPHER_EPM_FERSERVIZI CLOUD",
  "PBCS MIR": "APEX_PBCS MIR",
  "TIM - ACILIA 1": "DC-CLOUD - AURORA 1",
  "TIM - ACILIA 2": "DC-CLOUD - AURORA 2",
  "FST-CED AZURE FSI-NE": "TECH-CED AZURE FSI-NE",
  "FST-CED ORACLE OCI-FR": "TECH-CED ORACLE OCI-FR",
  "FST-CED AZURE AVS-NE": "TECH-CED AZURE AVS-NE",
  "FST-CED RFI-100": "TECH-CED NET-100",
  "FST-CED SOC-3": "TECH-CED SOC-3",
  "FST-CED ORACLE OCI-MI": "TECH-CED ORACLE OCI-MI",
  "FST-CED TI-19": "TECH-CED TI-19",
  "FST-CED RFI-64": "TECH-CED NET-64",
  "ROMA CASILINA VECCHIA 86": "DC - CASILINA HUB",
  "FST-CED RFI-171": "TECH-CED NET-171",
  "FST-CED RFI-110": "TECH-CED NET-110",
  "FST-CED RFI-74": "TECH-CED NET-74",
  "FST-CED TI-17": "TECH-CED TI-17",
  "FST-CED RFI-43": "TECH-CED NET-43",
  "FST-CED SOC-8": "TECH-CED SOC-8",
  "DC TIAKY-EX SCALO PRENESTINO": "DC HYPERION-EX SCALO PRENESTINO",
  "FST-CED RFI-14": "TECH-CED NET-14",
  "FST-CED RFI-183": "TECH-CED NET-183",
  "FST-CED RFI-62": "TECH-CED NET-62",
  "FST-CED RFI-7": "TECH-CED NET-7",
  "FST-CED RFI-194": "TECH-CED NET-194",
  "FST-CED RFI-119": "TECH-CED NET-119",
  "FST-CED RFI-193": "TECH-CED NET-193",
  "FST-CED RFI-195": "TECH-CED NET-195",
  "FST-CED TI-15": "TECH-CED TI-15",
  "FST-CED RFI-144": "TECH-CED NET-144",
  "FST-CED RFI-21": "TECH-CED NET-21",
  "FST-CED RFI-73": "TECH-CED NET-73",
  "TIM - ROZZANO": "DC-CLOUD - ROZZANO",
  "ROMA CASAL BOCCONE 188": "DC - BOCCONE CAMPUS",
  "KYNDRYL_PERO": "CLOUD_DATACENTER_PERO",
  "FST-CED RFI-176": "TECH-CED NET-176",
  "FST-CED SOC-1": "TECH-CED SOC-1",
  "FST-CED SOC-7": "TECH-CED SOC-7",
  "DC TIAKY-EX POMEZIA": "DC HYPERION-EX POMEZIA",
  "FST-CED SOC-14": "TECH-CED SOC-14",
  "FST-CED RFI-18": "TECH-CED NET-18",
  "FST-CED TI-6": "TECH-CED TI-6",
  "BARI CENTRALE": "HUB BARI LEVANTE",
  "FST-CED TI-8": "TECH-CED TI-8",
  "FST-CED RFI-127": "TECH-CED NET-127",
  "FST-CED TI-4": "TECH-CED TI-4",
  "FST-CED RFI-139": "TECH-CED NET-139",
  "KYNDRYL_CASTELLETTO": "CLOUD_DATACENTER_CASTELLETTO",
  "FST-CED TI-12": "TECH-CED TI-12",
  "PIAZZA NELLO E CARLO ROSSELLI": "CAMPUS ROSSELLI TECH",
  "FST-CED TI-30": "TECH-CED TI-30",
  "VENEZIA SANTA LUCIA": "HUB VENEZIA LAGUNA",
  "ANCONA": "HUB ANCONA ADRIATICA",
  "FST-CED TI-20": "TECH-CED TI-20",
  "BOLOGNA CENTRALE": "HUB BOLOGNA EMILIA",
  "ALESSANDRIA": "HUB ALESSANDRIA NORD",
  "FST-CED TI-7": "TECH-CED TI-7",
  "FST-CED TI-2": "TECH-CED TI-2",
  "FST-CED RFI-98": "TECH-CED NET-98",
  "FST-CED TI-28": "TECH-CED TI-28",
  "FST-CED TI-27": "TECH-CED TI-27",
  "FST-CED TI-11": "TECH-CED TI-11",
  "FST-CED TI-9": "TECH-CED TI-9",
  "FST-CED RFI-177": "TECH-CED NET-177",
  "FST-CED TI-23": "TECH-CED TI-23",
  "MILITELLO": "HUB MILITELLO SUD",
  "FST-CED RFI-181": "TECH-CED NET-181",
  "ROMA TERMINI": "HUB ROMA TERMINI OVEST",
  "FST-CED TI-1": "TECH-CED TI-1",
  "FST-CED TI-10": "TECH-CED TI-10",
  "FST-CED RFI-95": "TECH-CED NET-95",
  "FST-CED TI-18": "TECH-CED TI-18",
  "FST-CED AZURE FSI": "TECH-CED AZURE FSI",
  "FST-CED RFI-65": "TECH-CED NET-65",
  "SULMONA": "HUB SULMONA VALLE",
  "FST-CED TI-3": "TECH-CED TI-3",
  "FST-CED TI-29": "TECH-CED TI-29",
  "FST-CED TI-21": "TECH-CED TI-21",
  "FST-CED TI-5": "TECH-CED TI-5",
  "FST-CED RFI-120": "TECH-CED NET-120",
  "FST-CED TI-13": "TECH-CED TI-13",
  "FST-CED TI-25": "TECH-CED TI-25",
  "FST-CED TI-24": "TECH-CED TI-24",
  "FST-CED RFI-42": "TECH-CED NET-42",
  "FST-CED TI-26": "TECH-CED TI-26",
  "FST-CED TI-16": "TECH-CED TI-16",
  "FST-CED RFI-118": "TECH-CED NET-118",
  "FS Security": "Aegis Corporate Security",
  "FSTechnology": "InnovaTech Digital",
  "FSTechnology S.p.A.": "InnovaTech Digital S.p.A.",
  "Fercredit": "CreditTrans Finance",
  "fercredit": "CreditTrans Finance",
  "Ferrrovie del Sud Est e Servizi Automobilistici": "Mediterranea Mobilità & Trasporti",
  "Ferservizi": "Shared Services Corp",
  "Fondazione FS": "Heritage Transport Foundation",
  "Grandi Stazioni Rail": "Central Hub Rail",
  "Italferr": "Enterprise Italferr",
  "RFI": "INFRARETE NAZIONALE",
  "SBB": "Alpine Rail Group",
  "TRENORD": "NordRail Express",
  "Trenitalia": "VeloceRail",
  "Trenitalia Francia": "VeloceRail France",
  "CYBER": "CYBER SECURITY & DEFENSE",
  "POLO INFRASTRUTTURA": "DIVISIONE RETI & INFRASTRUTTURE",
  "POLO LOGISTICA": "DIVISIONE LOGISTICA AVANZATA",
  "POLO PASSEGGERI": "DIVISIONE MOBILITA PASSEGGERI",
  "POLO URBANO": "DIVISIONE SVILUPPO URBANO",
  "SHARED & SERVICE": "SERVIZI CONDIVISI CORPORATE",
  "BURS-BUSITALIA RAIL SERVICE": "BURS-ROADRAIL CONNECT",
  "BUSITALIA": "ROADRAIL MOBILITY",
  "BUSITALIA - SITA NORD S.R.L.": "ROADRAIL MOBILITY - SITA NORD S.R.L.",
  "FERROVIE SUD EST": "MEDITERRANEA TRASPORTI",
  "FERSERVIZI": "CORPORATE SHARED SERVICES",
  "FS PARK": "METROPARK SOLUTIONS",
  "FS SISTEMI URBANI": "URBAN REAL ESTATE NETWORK",
  "FS-HOLDING": "GLOBAL MOBILITY HOLDING",
  "FSSECURITY": "GLOBAL SECURITY SHIELD",
  "FSTECH DCPA": "INNOVATECH DCPA",
  "FSTECHNOLOGY": "INNOVATECH DIGITAL",
  "GRANDI STAZIONI RAIL S.P.A.": "CENTRAL STATIONS RAIL S.P.A.",
  "GRUPPO FS": "GLOBAL MOBILITY GROUP",
  "ITALFERR S.P.A.": "ENGINEERING TRANSRAIL S.P.A.",
  "MERCITALIA INTERMODAL S.P.A.": "INTERMODAL FREIGHT S.P.A.",
  "MERCITALIA LOGISTICS": "LOGISFREIGHT NETWORKS",
  "MERCITALIA RAIL": "LOGISFREIGHT RAIL",
  "MERCITALIA SHUNTING & TERMINAL SRL": "LOGISFREIGHT TERMINAL SRL",
  "TERMINALI ITALIA": "TERMINAL HUBS ITALIA",
  "TRENI TURISTICI": "PANORAMIC RAILWAYS",
  "TRENITALIA": "VELOCERAIL",
  "TRENITALIA-TPER": "VELOCERAIL-TPER",
  "FE2 - FSE TRASPORTO FERRO": "FE2 - MEDITERRANEA TRASPORTO FERRO",
  "CLIENTE PASSEGGERI": "CLIENTE MOBILITA PASSEGGERI",
  "TER - TPER": "TER - EMILIA TRASPORTI",
  "E49 - TERMINALI ITALIA": "E49 - TERMINAL HUBS",
  "CLIENTE CENTRALIZZATO": "CLIENTE CORPORATE GLOBAL",
  "CLIENTE LOGISTICA": "CLIENTE LOGISTICA AVANZATA",
  "N.D. - FONDAZIONE FS": "N.D. - HERITAGE FOUNDATION",
  "ITAL - ITALFERR": "ITAL - TRANSRAIL ENGINEERING",
  "K02 - ATAF GESTIONI": "K02 - URBAN TRANSIT",
  "N.D. - FS INTERNATIONAL": "N.D. - GLOBAL RAILWAY INT",
  "N.D. - ILSA RAIL": "N.D. - IBERIA FAST RAIL",
  "AC1 - TRAINOSE": "AC1 - HELLENIC RAILWAYS",
  "TTI - TRENI TURISTICI ITALIANI": "TTI - PANORAMIC RAILWAYS",
  "I&SO": "Enterprise I&SO",
  "S29 - TRENORD SRL": "S29 - NORDRAIL EXPRESS SRL",
  "FS01 - RETE FERROVIARIA ITALIANA  S.P.A.": "FS01 - INFRARETE NAZIONALE S.P.A.",
  "ITF - TRENITALIA S.P.A.": "ITF - VELOCERAIL S.P.A.",
  "MIR - MERCITALIA RAIL S.R.L.": "MIR - LOGISFREIGHT RAIL S.R.L.",
  "AR1 - FSSECURITY": "AR1 - AEGIS_SEC",
  "FSSU - FERROVIE SISTEMI URBANI": "FSSU - URBAN REAL ESTATE",
  "FST - FSTECHNOLOGY - CYBER": "FST - INNOVATECH CYBER DEFENSE",
  "METR - METROPARK": "METR - METROPARKING SOLUTIONS",
  "CE10 - MERCITALIA INTERMODAL (EX CEMAT S.P.A.)": "CE10 - LOGISFREIGHT INTERMODAL (EX CEMAT S.P.A.)",
  "E10 - MERCITALIA SHUNTING & TERMINAL S.R.L. (EX SERFER)": "E10 - LOGISFREIGHT SHUNTING & TERMINAL S.R.L. (EX SERFER)",
  "FSL - MERCITALIA LOGISTIC S.P.A.": "FSL - LOGISFREIGHT LOGISTIC S.P.A.",
  "FSHD - FERROVIE DELLO STATO ITALIANE S.P.A.": "FSHD - GLOBAL MOBILITY HOLDING S.P.A.",
  "FSCS - FERSERVIZI S.P.A.": "FSCS - SHARED SERVICES S.P.A.",
  "FSTG - BUSITALIA SITA NORD": "FSTG - ROADRAIL SITA NORD",
  "FST - FSTECHNOLOGY": "FST - INNOVATECH DIGITAL",
  "K08 - BUSITALIA VENETO": "K08 - ROADRAIL VENETO",
  "GS01 - GRANDI STAZIONI S.P.A.": "GS01 - CENTRAL STATIONS S.P.A.",
  "K13 - BUSITALIA CAMPANIA": "K13 - ROADRAIL CAMPANIA",
  "FBUS - BUSITALIA RAIL SERVICE": "FBUS - ROADRAIL RAIL SERVICE",
  "SERVIZI CSAC DC AETA/TIAKY E ALTRO": "SERVIZI CSAC DC HYBRID/HYPERION E ALTRO",
  "SERVIZI LAN": "SERVIZI RETE LAN ENTERPRISE",
  "SERVIZI PROFESSIONALI PER CONDUZIONE SERVIZI  INFRASTRUTTURALI": "SERVIZI PROFESSIONALI GESTIONE INFRASTRUTTURE CLOUD",
  "SERVIZI WAN-CSDR": "SERVIZI WAN-ENTERPRISE NET",
  "SOLUZIONE SICUREZZA PER FW E-O": "SOLUZIONE FIREWALL & EDGE SECURITY",
  "NOC/D_INT": "NETWORK_OPS_CENTER_INT",
  "PRESIDIO FERSERVIZI": "PRESIDIO SERVIZI CONDIVISI",
  "SERVICE DESK": "ENTERPRISE HELPDESK",
  "PREVISIONALE": "FORECAST_ANALYTICS",
  "ALTRO": "SERVIZI GENERALI DI SUPPORTO",
  "DBP Corporate e Urbano": "Digital Partner Corporate e Urbano",
  "Cyber Security Solutions & Operations": "Cyber Defense Advanced Solutions & Operations",
  "DFinfrastrutture": "Enterprise DFinfrastrutture",
  "Delivery Farm": "Agile Delivery Unit",
  "Infrastrutture": "Cloud & Systems",
  "Infrastructure & Service Operations": "Enterprise Infrastructure & Service Operations",
  "I&SO – Tecnologie ICT di Campo": "Enterprise I&SO – Tecnologie ICT di Campo",
  "Delivery FARM": "Agile Delivery Unit",
  "Cyber Security Solution Operation": "Cyber Defense Advanced Solution Operation",
  "FSTECH DIGITALIZATION": "InnovaTech DIGITALIZATION",
  "DEVOPS RFI": "DEVOPS InfraRete",
  "DevOps RFI": "DevOps InfraRete",
  "Technical PMO & Transition": "Enterprise Technical PMO & Transition",
  "Governance Tecnico Operativa": "Enterprise Governance Tecnico Operativa",
  "DF Infrastrutture": "DF Cloud & Systems",
  "DELIVERY FARM INFRASTRUTTURE": "Agile Delivery Unit Cloud & Systems",
  "Delivery Farm Infrastrutture": "Agile Delivery Unit Cloud & Systems",
  "Digital Business Partner Infrastrutture": "Digital Business Partner Cloud & Systems",
  "DBP Infrastrutture": "Digital Partner Cloud & Systems",
  "Digital Business Partner Mobilità": "Enterprise Digital Business Partner Mobilità",
  "Infrastructure & Service Operation": "Enterprise Infrastructure & Service Operation",
  "Infrastructrure & Service Operation": "Enterprise Infrastructrure & Service Operation",
  "INFRASTRUCTURE& PROJECT MANAGEMENT": "Enterprise INFRASTRUCTURE& PROJECT MANAGEMENT",
  "Infrastrutture & Service Operation": "Cloud & Systems & Service Operation",
  "Infrastructure &Project Management": "Enterprise Infrastructure &Project Management",
  "Infrastructure & Project & Project Management": "Enterprise Infrastructure & Project & Project Management",
  "INFRASTRUCTURE & SERVICE OPERATIONS": "Enterprise INFRASTRUCTURE & SERVICE OPERATIONS",
  "INFRASTRUCTURE & SERVICE OPERATION": "Enterprise INFRASTRUCTURE & SERVICE OPERATION",
  "Infrastrutture &SO": "Cloud & Systems &SO",
  "I&SO/ INFRASTRUCTURE & PROJECT MANAGEMENT": "Enterprise I&SO/ INFRASTRUCTURE & PROJECT MANAGEMENT",
  "I&SO/Infrastructure & Project Management": "Enterprise I&SO/Infrastructure & Project Management",
  "DIGITAL BUSINESS PARTNER INFRASTRUTTURE": "DIGITAL BUSINESS PARTNER Cloud & Systems",
  "Infrastrutture and service operations - Infrastrutture": "Cloud & Systems and service operations - Cloud & Systems",
  "Infrastructure & Service Operations/Infrastructure & Project Management/Infrastructure Solutioning": "Enterprise Infrastructure & Service Operations/Infrastructure & Project Management/Infrastructure Solutioning",
  "Infrastrutture & SO": "Cloud & Systems & SO",
  "DF TECHNICAL PMO, TRANSITION & DEVOPS": "Enterprise DF TECHNICAL PMO, TRANSITION & DEVOPS",
  "CYBER SECURITY SOLUTION & OPERATION": "Cyber Defense Advanced SOLUTION & OPERATION",
  "CYBER SECURITY SOLUTIONS & OPERATIONS": "Cyber Defense Advanced SOLUTIONS & OPERATIONS",
  "Cyber Security Solutions e Operations": "Cyber Defense Advanced Solutions e Operations",
  "E2E Service Management Operation Infrastruttura": "Enterprise E2E Service Management Operation Infrastruttura",
  "INFRASTRUCTURE & SERVICE OPERATIONS/INFRASTRUTTURE": "INFRASTRUCTURE & SERVICE OPERATIONS/Cloud & Systems",
  "Infrastrutture and service operations - infrastrutture": "Cloud & Systems and service operations - Cloud & Systems",
  "Digital Farm - Infrastrutture": "Digital Farm - Cloud & Systems",
  "I&SO - Infrastrutture": "I&SO - Cloud & Systems",
  "I&SO- Infrastrutture": "I&SO- Cloud & Systems",
  "E2E Service Management Infrastruttura Ferroviaria": "Enterprise E2E Service Management Infrastruttura Ferroviaria",
  "DBP Mobilità": "Digital Partner Mobilità",
  "Infrastructure - Service Operations": "Enterprise Infrastructure - Service Operations",
  "INFRASTRUCTURE & PROJECT MANAGEMENT": "Enterprise INFRASTRUCTURE & PROJECT MANAGEMENT",
  ": Infrastrutture and service operations - Infrastrutture": ": Cloud & Systems and service operations - Cloud & Systems",
  "I&SO - Infrastructure & Project Management": "Enterprise I&SO - Infrastructure & Project Management",
  "Infrastructure e Service Operation": "Enterprise Infrastructure e Service Operation",
  "I&SO/Infrastrutture": "I&SO/Cloud & Systems",
  "INFRASTRUCTURE & SERVICE OPERATIONS - INFRASTRUTTURE": "INFRASTRUCTURE & SERVICE OPERATIONS - Cloud & Systems",
  "I&SO Infrastructure & Service Operations": "Enterprise I&SO Infrastructure & Service Operations",
  "BUTP323": "APP-TP-323",
  "BUTP122": "APP-TP-122",
  "BUTP108": "APP-TP-108",
  "BUTP109": "APP-TP-109",
  "BUTP003": "APP-TP-003",
  "BUTP111": "APP-TP-111",
  "BUTP208": "APP-TP-208",
  "BUTP115": "APP-TP-115",
  "BUTP121": "APP-TP-121",
  "BUTP118": "APP-TP-118",
  "BUTP123": "APP-TP-123",
  "BUTP158": "APP-TP-158",
  "BUTP277": "APP-TP-277",
  "BUTP117": "APP-TP-117",
  "BUTP113": "APP-TP-113",
  "BUTP107": "APP-TP-107",
  "BUTP116": "APP-TP-116",
  "BUTP112": "APP-TP-112",
  "BUTP131": "APP-TP-131",
  "BUTP091": "APP-TP-091",
  "BUTP077": "APP-TP-077",
  "BUTP049": "APP-TP-049",
  "BUTP149": "APP-TP-149",
  "BUTP012": "APP-TP-012",
  "BUTP190": "APP-TP-190",
  "BUTP087": "APP-TP-087",
  "BUTP185": "APP-TP-185",
  "BUTP130": "APP-TP-130",
  "BUTP181": "APP-TP-181",
  "BUML036": "APP-ML-036",
  "BUTP152": "APP-TP-152",
  "BUTP195": "APP-TP-195",
  "BUTP071": "APP-TP-071",
  "BUTP055": "APP-TP-055",
  "BUIF110": "APP-IF-110",
  "BUTP151": "APP-TP-151",
  "BUIF083": "APP-IF-083",
  "BUTP006": "APP-TP-006",
  "BUTP146": "APP-TP-146",
  "BUIF081": "APP-IF-081",
  "BUIF108": "APP-IF-108",
  "BUTP023": "APP-TP-023",
  "BUTP004": "APP-TP-004",
  "BUTP086": "APP-TP-086",
  "BUTP200": "APP-TP-200",
  "BUIF246": "APP-IF-246",
  "BUTP090": "APP-TP-090",
  "BUCP185": "APP-CP-185",
  "BUCP411": "APP-CP-411",
  "BUIF008": "APP-IF-008",
  "BUIF250": "APP-IF-250",
  "BUIF006": "APP-IF-006",
  "BUIF029": "APP-IF-029",
  "BUIF107": "APP-IF-107",
  "BUIF120": "APP-IF-120",
  "BUIF290": "APP-IF-290",
  "BUIF065": "APP-IF-065",
  "BUIF139": "APP-IF-139",
  "BUCP468": "APP-CP-468",
  "BUCP344": "APP-CP-344",
  "NUOVA BUTP 3": "SYS-NUOVA BUTP 3",
  "BUTP381": "APP-TP-381",
  "BUTP329": "APP-TP-329",
  "MRK017": "SYS-MRK017",
  "MRK001": "SYS-MRK001",
  "MRK009": "SYS-MRK009",
  "MRK026": "SYS-MRK026",
  "MRK006": "SYS-MRK006",
  "BUTP308": "APP-TP-308",
  "BUTP344": "APP-TP-344",
  "NUOVA BUTP 4": "SYS-NUOVA BUTP 4",
  "BUTP100": "APP-TP-100",
  "BUTP093": "APP-TP-093",
  "BUTP014": "APP-TP-014",
  "BUTP270": "APP-TP-270",
  "BUTP013": "APP-TP-013",
  "BUTP056": "APP-TP-056",
  "BUTP293": "APP-TP-293",
  "BUTP001": "APP-TP-001",
  "BUTP186": "APP-TP-186",
  "BUIT104": "APP-IT-104",
  "BUTP201": "APP-TP-201",
  "BUTP202": "APP-TP-202",
  "BUML060": "APP-ML-060",
  "BUML059": "APP-ML-059",
  "BUIF022": "APP-IF-022",
  "BUIF013": "APP-IF-013",
  "BUIF055": "APP-IF-055",
  "BUIF097": "APP-IF-097",
  "BUTP018": "APP-TP-018",
  "BUTP065": "APP-TP-065",
  "BUML003": "APP-ML-003",
  "BUML006": "APP-ML-006",
  "BUML011": "APP-ML-011",
  "BUIT117": "APP-IT-117",
  "BUTP175": "APP-TP-175",
  "BUIF214": "APP-IF-214",
  "BUTP376": "APP-TP-376",
  "BUTP199": "APP-TP-199",
  "BUTP015": "APP-TP-015",
  "BUTP365": "APP-TP-365",
  "BUTP400": "APP-TP-400",
  "BUCPXXXX": "SYS-BUCPXXXX",
  "BUIF210": "APP-IF-210",
  "BUTP309": "APP-TP-309",
  "BUTP024": "APP-TP-024",
  "BUML029": "APP-ML-029",
  "BUTP165": "APP-TP-165",
  "BUTP095": "APP-TP-095",
  "BUTP094": "APP-TP-094",
  "BUTP072": "APP-TP-072",
  "BUTP097": "APP-TP-097",
  "BUIF103": "APP-IF-103",
  "BUTP053": "APP-TP-053",
  "BUIT046": "APP-IT-046",
  "BUTP156": "APP-TP-156",
  "BUTP141": "APP-TP-141",
  "BUTP196": "APP-TP-196",
  "BUTP105": "APP-TP-105",
  "BUTP128": "APP-TP-128",
  "BUTP174": "APP-TP-174",
  "BUTP033": "APP-TP-033",
  "BUIF095": "APP-IF-095",
  "BUIF140": "APP-IF-140",
  "BUIF105": "APP-IF-105",
  "BUTP054": "APP-TP-054",
  "BUTP119": "APP-TP-119",
  "BUIF086": "APP-IF-086",
  "BUTP096": "APP-TP-096",
  "BUCP032": "APP-CP-032",
  "BUTP103": "APP-TP-103",
  "BUTP321": "APP-TP-321",
  "BUTP092": "APP-TP-092",
  "BUTP137": "APP-TP-137",
  "BUML022": "APP-ML-022",
  "BUIF043": "APP-IF-043",
  "BUTP176": "APP-TP-176",
  "BUTP273": "APP-TP-273",
  "BUIF019": "APP-IF-019",
  "BUIF059": "APP-IF-059",
  "BUTP198": "APP-TP-198",
  "BUIF094": "APP-IF-094",
  "BUTP120": "APP-TP-120",
  "BUTP359": "APP-TP-359",
  "BUTP106": "APP-TP-106",
  "BUML030": "APP-ML-030",
  "BUTP304": "APP-TP-304",
  "BUML015": "APP-ML-015",
  "BUCP073": "APP-CP-073",
  "BUCP470": "APP-CP-470",
  "BUCP062": "APP-CP-062",
  "BUCP031": "APP-CP-031",
  "BUCP308": "APP-CP-308",
  "BUIF009": "APP-IF-009",
  "BUTP373": "APP-TP-373",
  "BUIF069": "APP-IF-069",
  "BUCP474": "APP-CP-474",
  "CSOC - FSTECH DCPA": "SYS-CSOC - FSTECH DCPA",
  "BUIF074": "APP-IF-074",
  "BUIF079": "APP-IF-079",
  "BUIF011": "APP-IF-011",
  "BUCP040": "APP-CP-040",
  "BUIF078": "APP-IF-078",
  "BUIF092": "APP-IF-092",
  "BUIF073": "APP-IF-073",
  "BUIF037": "APP-IF-037",
  "BUIF010": "APP-IF-010",
  "BUCP076": "APP-CP-076",
  "BUIF252": "APP-IF-252",
  "BUIF071": "APP-IF-071",
  "BUTP026": "APP-TP-026",
  "BUIF076": "APP-IF-076",
  "BUIF075": "APP-IF-075",
  "BUIF072": "APP-IF-072",
  "BUIF077": "APP-IF-077",
  "BUML033": "APP-ML-033",
  "BUTP138": "APP-TP-138",
  "BUML034": "APP-ML-034",
  "BUTP035": "APP-TP-035",
  "BUTP025": "APP-TP-025",
  "BUTP081": "APP-TP-081",
  "BUIF199": "APP-IF-199",
  "BUCP021": "APP-CP-021",
  "BUIT132": "APP-IT-132",
  "BUTP187": "APP-TP-187",
  "BUTP041": "APP-TP-041",
  "BUTP078": "APP-TP-078",
  "BUTP036": "APP-TP-036",
  "BUTP030": "APP-TP-030",
  "BUIF053": "APP-IF-053",
  "BUIF109": "APP-IF-109",
  "BUIF085": "APP-IF-085",
  "BUIF133": "APP-IF-133",
  "BUIF052": "APP-IF-052",
  "BUIF012": "APP-IF-012",
  "BUIF054": "APP-IF-054",
  "BUTP142": "APP-TP-142",
  "BUTP168": "APP-TP-168",
  "BUIF209": "APP-IF-209",
  "BUIF088": "APP-IF-088",
  "BUIF042": "APP-IF-042",
  "BUIF138": "APP-IF-138",
  "BUIF208": "APP-IF-208",
  "BUIF117": "APP-IF-117",
  "BUIF264": "APP-IF-264",
  "BUIF265": "APP-IF-265",
  "BUIF266": "APP-IF-266",
  "BUIF269": "APP-IF-269",
  "BUCP134": "APP-CP-134",
  "BUCP118": "APP-CP-118",
  "BUCP145": "APP-CP-145",
  "BUCP156": "APP-CP-156",
  "BUCP141": "APP-CP-141",
  "BUCP151": "APP-CP-151",
  "BUCP127": "APP-CP-127",
  "BUCP136": "APP-CP-136",
  "BUCP155": "APP-CP-155",
  "BUCP100": "APP-CP-100",
  "BUCP154": "APP-CP-154",
  "BUCP142": "APP-CP-142",
  "BUCP135": "APP-CP-135",
  "BUCP146": "APP-CP-146",
  "BUCP119": "APP-CP-119",
  "BUCP150": "APP-CP-150",
  "BUCP066": "APP-CP-066",
  "BUCP129": "APP-CP-129",
  "BUCP133": "APP-CP-133",
  "BUCP147": "APP-CP-147",
  "BUCP137": "APP-CP-137",
  "BUCP001": "APP-CP-001",
  "BUCP130": "APP-CP-130",
  "BUCP064": "APP-CP-064",
  "BUCP132": "APP-CP-132",
  "BUTP209": "APP-TP-209",
  "BUCP126": "APP-CP-126",
  "BUCP082": "APP-CP-082",
  "BUCP120": "APP-CP-120",
  "BUTP206": "APP-TP-206",
  "BUTP223": "APP-TP-223",
  "BUCP114": "APP-CP-114",
  "BUCP121": "APP-CP-121",
  "BUCP075": "APP-CP-075",
  "BUCP006": "APP-CP-006",
  "BUCP010": "APP-CP-010",
  "BUIT047": "APP-IT-047",
  "BUCP039": "APP-CP-039",
  "BUCP023": "APP-CP-023",
  "BUCP022": "APP-CP-022",
  "BUCP007": "APP-CP-007",
  "BUCP069": "APP-CP-069",
  "BUCP025": "APP-CP-025",
  "BUCP030": "APP-CP-030",
  "BUCP061": "APP-CP-061",
  "BUCP096": "APP-CP-096",
  "BUCP033": "APP-CP-033",
  "BUCP034": "APP-CP-034",
  "BUCP035": "APP-CP-035",
  "BUIT125": "APP-IT-125",
  "BUCP067": "APP-CP-067",
  "BUCP095": "APP-CP-095",
  "BUCP016": "APP-CP-016",
  "BUCP080": "APP-CP-080",
  "BUCP070": "APP-CP-070",
  "BUCP071": "APP-CP-071",
  "BUCP011": "APP-CP-011",
  "BUTP204": "APP-TP-204",
  "BUIF226": "APP-IF-226",
  "BUCP361": "APP-CP-361",
  "ITALFERR - FSTECH DCPA": "SYS-ITALFERR - FSTECH DCPA",
  "BUTP222": "APP-TP-222",
  "BUTP213": "APP-TP-213",
  "BUCP325": "APP-CP-325",
  "BUTP217": "APP-TP-217",
  "BUTP140": "APP-TP-140",
  "BUIT102": "APP-IT-102",
  "BUCP110": "APP-CP-110",
  "BUCP106": "APP-CP-106",
  "BUCP149": "APP-CP-149",
  "BUIF155": "APP-IF-155",
  "BUML005": "APP-ML-005",
  "BUML063": "APP-ML-063",
  "BUIF034": "APP-IF-034",
  "BUML050": "APP-ML-050",
  "BUTP260": "APP-TP-260",
  "BUTP017": "APP-TP-017",
  "BUIF161": "APP-IF-161",
  "BUIF262": "APP-IF-262",
  "BUML049": "APP-ML-049",
  "BUML012": "APP-ML-012",
  "BUML016": "APP-ML-016",
  "BUTP059": "APP-TP-059",
  "BUCP059": "APP-CP-059",
  "BUML035": "APP-ML-035",
  "BUIF268": "APP-IF-268",
  "BUML009": "APP-ML-009",
  "BUML032": "APP-ML-032",
  "BUTP189": "APP-TP-189",
  "BUTP114": "APP-TP-114",
  "BUTP110": "APP-TP-110",
  "BUTP104": "APP-TP-104",
  "BUCP117": "APP-CP-117",
  "BUIF098": "APP-IF-098",
  "BUIF122": "APP-IF-122",
  "BUIF033": "APP-IF-033",
  "BUIF243": "APP-IF-243",
  "BUIF096": "APP-IF-096",
  "BUIF048": "APP-IF-048",
  "BUIF035": "APP-IF-035",
  "BUIF020": "APP-IF-020",
  "BUIF220": "APP-IF-220",
  "BUIF229": "APP-IF-229",
  "BUIF101": "APP-IF-101",
  "BUIF038": "APP-IF-038",
  "BUIF031": "APP-IF-031",
  "BUIF260": "APP-IF-260",
  "BUIF223": "APP-IF-223",
  "BUIF082": "APP-IF-082",
  "BUIF126": "APP-IF-126",
  "BUIF283": "APP-IF-283",
  "BUIF023": "APP-IF-023",
  "BUIF141": "APP-IF-141",
  "BUIF003": "APP-IF-003",
  "BUIF025": "APP-IF-025",
  "BUIF036": "APP-IF-036",
  "BUIF001": "APP-IF-001",
  "BUIF060": "APP-IF-060",
  "BUIF267": "APP-IF-267",
  "BUIF039": "APP-IF-039",
  "BUIF026": "APP-IF-026",
  "BUIF070": "APP-IF-070",
  "BUIF091": "APP-IF-091",
  "BUIF030": "APP-IF-030",
  "BUIF124": "APP-IF-124",
  "BUIF049": "APP-IF-049",
  "BUIF100": "APP-IF-100",
  "BUIF121": "APP-IF-121",
  "BUIF007": "APP-IF-007",
  "BUIF064": "APP-IF-064",
  "BUIF067": "APP-IF-067",
  "BUIF015": "APP-IF-015",
  "BUIF040": "APP-IF-040",
  "BUIF045": "APP-IF-045",
  "BUIF063": "APP-IF-063",
  "BUIF273": "APP-IF-273",
  "BUTP155": "APP-TP-155",
  "BUTP082": "APP-TP-082",
  "BUIF099": "APP-IF-099",
  "BUTP178": "APP-TP-178",
  "BUIT039": "APP-IT-039",
  "BUIT036": "APP-IT-036",
  "BUTP134": "APP-TP-134",
  "BUTP255": "APP-TP-255",
  "BUTP287": "APP-TP-287",
  "BUCP093": "APP-CP-093",
  "BUIF517": "APP-IF-517",
  "BUIT042": "APP-IT-042",
  "BUTP048": "APP-TP-048",
  "BUML007": "APP-ML-007",
  "BUML044": "APP-ML-044",
  "BUTP219": "APP-TP-219",
  "BUTP052": "APP-TP-052",
  "BUCP108": "APP-CP-108",
  "BUTP171": "APP-TP-171",
  "BUTP170": "APP-TP-170",
  "BUTP027": "APP-TP-027",
  "BUML031": "APP-ML-031",
  "BUTP220": "APP-TP-220",
  "BUTP281": "APP-TP-281",
  "BUTP009": "APP-TP-009",
  "BUTP010": "APP-TP-010",
  "BUTP070": "APP-TP-070",
  "BUTP132": "APP-TP-132",
  "BUTP145": "APP-TP-145",
  "BUTP272": "APP-TP-272",
  "BUTP043": "APP-TP-043",
  "BUML008": "APP-ML-008",
  "BUCP063": "APP-CP-063",
  "BUML014": "APP-ML-014",
  "BUML002": "APP-ML-002",
  "BUTP058": "APP-TP-058",
  "BUTP177": "APP-TP-177",
  "BUTP085": "APP-TP-085",
  "BUTP197": "APP-TP-197",
  "BUTP062": "APP-TP-062",
  "BUTP169": "APP-TP-169",
  "BUTP194": "APP-TP-194",
  "BUTP172": "APP-TP-172",
  "BUTP133": "APP-TP-133",
  "BUTP163": "APP-TP-163",
  "BUTP064": "APP-TP-064",
  "BUTP292": "APP-TP-292",
  "BUTP154": "APP-TP-154",
  "BUTP034": "APP-TP-034",
  "BUTP150": "APP-TP-150",
  "BUCP148": "APP-CP-148",
  "BUIT199": "APP-IT-199",
  "BUIF511": "APP-IF-511",
  "BUIF080": "APP-IF-080",
  "BUCP044": "APP-CP-044",
  "BUCP041": "APP-CP-041",
  "BUCP046": "APP-CP-046",
  "BUCP042": "APP-CP-042",
  "BUCP004": "APP-CP-004",
  "BUCP311": "APP-CP-311",
  "BUCP005": "APP-CP-005",
  "BUCP312": "APP-CP-312",
  "BUCP050": "APP-CP-050",
  "BUTP011": "APP-TP-011",
  "BUML017": "APP-ML-017",
  "BUCP048": "APP-CP-048",
  "BUCP310": "APP-CP-310",
  "BUIF244": "APP-IF-244",
  "BUIF028": "APP-IF-028",
  "BUTP193": "APP-TP-193",
  "BUIF213": "APP-IF-213",
  "BUIF057": "APP-IF-057",
  "BUIF147": "APP-IF-147",
  "BUML062": "APP-ML-062",
  "BUML069": "APP-ML-069",
  "BUTP320": "APP-TP-320",
  "BUIT101": "APP-IT-101",
  "BUTP089": "APP-TP-089",
  "BUIF027": "APP-IF-027",
  "BUML051": "APP-ML-051",
  "BUIT038": "APP-IT-038",
  "BUCP421": "APP-CP-421",
  "BUSINESS APPLICATION NON ANCORA NOTA": "SYS-BUSINESS APPLICATION NON ANCORA NOTA",
  "BUCP496": "APP-CP-496",
  "BUTP297": "APP-TP-297",
  "BUTP084": "APP-TP-084",
  "BUIF239": "APP-IF-239",
  "BUIT113": "APP-IT-113",
  "BUIF106": "APP-IF-106",
  "BUIT270": "APP-IT-270",
  "MRK015": "SYS-MRK015",
  "MRK029": "SYS-MRK029",
  "MRK012": "SYS-MRK012",
  "MRK022": "SYS-MRK022",
  "NUOVA BUTP 5": "SYS-NUOVA BUTP 5",
  "NUOVA BUTP 6": "SYS-NUOVA BUTP 6",
  "BUTP135": "APP-TP-135",
  "BUTP063": "APP-TP-063",
  "BUTP066": "APP-TP-066",
  "BUTP060": "APP-TP-060",
  "BUTP211": "APP-TP-211",
  "BUIF104": "APP-IF-104",
  "BUIF251": "APP-IF-251",
  "BUCP304": "APP-CP-304",
  "BUIT116": "APP-IT-116",
  "BUCP338": "APP-CP-338",
  "BUCP394": "APP-CP-394",
  "BUCP391": "APP-CP-391",
  "BUIF258": "APP-IF-258",
  "BUIF205": "APP-IF-205",
  "BUTP295": "APP-TP-295",
  "BUCP143": "APP-CP-143",
  "BUCP305": "APP-CP-305",
  "BUCP144": "APP-CP-144",
  "BUCP017": "APP-CP-017",
  "BUCP128": "APP-CP-128",
  "BUTP271": "APP-TP-271",
  "BUCP140": "APP-CP-140",
  "BUCP314": "APP-CP-314",
  "BUCP038": "APP-CP-038",
  "BUTP408": "APP-TP-408",
  "BUIF127": "APP-IF-127",
  "BUTP016": "APP-TP-016",
  "BUTP183": "APP-TP-183",
  "BUCP107": "APP-CP-107",
  "BUCP109": "APP-CP-109",
  "BUCP479": "APP-CP-479",
  "BUIT050": "APP-IT-050",
  "BUML019": "APP-ML-019",
  "BUIF261": "APP-IF-261",
  "BUTP079": "APP-TP-079",
  "BUML004": "APP-ML-004",
  "BUML903_TEMP": "SYS-BUML903_TEMP",
  "BUTP263": "APP-TP-263",
  "BUTP002": "APP-TP-002",
  "BUIF089": "APP-IF-089",
  "BUIF159": "APP-IF-159",
  "BUIF198": "APP-IF-198",
  "BUIF102": "APP-IF-102",
  "BUIF046": "APP-IF-046",
  "BUIF058": "APP-IF-058",
  "BUIF032": "APP-IF-032",
  "BUIF093": "APP-IF-093",
  "BUIF271": "APP-IF-271",
  "BUIF146": "APP-IF-146",
  "BUIF211": "APP-IF-211",
  "BUTP317": "APP-TP-317",
  "BUIT044": "APP-IT-044",
  "BUTP391": "APP-TP-391",
  "BUTP046": "APP-TP-046",
  "BUTP083": "APP-TP-083",
  "BUTP331": "APP-TP-331",
  "BUCP184": "APP-CP-184",
  "BUCP045": "APP-CP-045",
  "BUCP047": "APP-CP-047",
  "BUIF272": "APP-IF-272",
  "BUCP037": "APP-CP-037",
  "BUIT278": "APP-IT-278",
  "BUIT035": "APP-IT-035",
  "MRK014": "SYS-MRK014",
  "BUCP386": "APP-CP-386",
  "BUIF285": "APP-IF-285",
  "BUIT041": "APP-IT-041",
  "BUTP313": "APP-TP-313",
  "BUTP380": "APP-TP-380",
  "BUTP144": "APP-TP-144",
  "BUTP305": "APP-TP-305",
  "BUIF143": "APP-IF-143",
  "BUTP296": "APP-TP-296",
  "BUCP124": "APP-CP-124",
  "BUCP018": "APP-CP-018",
  "BUML020": "APP-ML-020",
  "BUML010": "APP-ML-010",
  "BUTP069": "APP-TP-069",
  "BUIF163": "APP-IF-163",
  "BUIF169": "APP-IF-169",
  "BUCP065": "APP-CP-065",
  "BUCP049": "APP-CP-049",
  "BUTP160": "APP-TP-160",
  "BUCP499": "APP-CP-499",
  "BUTP040": "APP-TP-040",
  "BUML080": "APP-ML-080",
  "CPFS0001": "SYS-CPFS0001",
  "BUTP409": "APP-TP-409",
  "MRK005": "SYS-MRK005",
  "MRK016": "SYS-MRK016",
  "BUIT126": "APP-IT-126",
  "BUIF130": "APP-IF-130",
  "BUIF129": "APP-IF-129",
  "BUIF235": "APP-IF-235",
  "BUIF152": "APP-IF-152",
  "BUIF156": "APP-IF-156",
  "BUIF017": "APP-IF-017",
  "BUIF066": "APP-IF-066",
  "BUIF228": "APP-IF-228",
  "BUTP392": "APP-TP-392",
  "BUTP191": "APP-TP-191",
  "BUTP180": "APP-TP-180",
  "BUTP047": "APP-TP-047",
  "BUTP215": "APP-TP-215",
  "BUCP307": "APP-CP-307",
  "BUIF270": "APP-IF-270",
  "BUIF144": "APP-IF-144",
  "MRK011": "SYS-MRK011",
  "MRK004": "SYS-MRK004",
  "BUIT202": "APP-IT-202",
  "BUIF500": "APP-IF-500",
  "BUCP337": "APP-CP-337",
  "BUTP315": "APP-TP-315",
  "BUIF275": "APP-IF-275",
  "BUIF151": "APP-IF-151",
  "BUTP389": "APP-TP-389",
  "BUIT121": "APP-IT-121",
  "NUOVA BUTP 1": "SYS-NUOVA BUTP 1",
  "MRK013": "SYS-MRK013",
  "BUIT120": "APP-IT-120",
  "BUCP158": "APP-CP-158",
  "BUIF504": "APP-IF-504",
  "BUIT108": "APP-IT-108",
  "BUTP207": "APP-TP-207",
  "BUCP084": "APP-CP-084",
  "BUTP042": "APP-TP-042",
  "BUIT201": "APP-IT-201",
  "BUIT081": "APP-IT-081",
  "NUOVA BUTP 2": "SYS-NUOVA BUTP 2",
  "BUIF216": "APP-IF-216",
  "BUCP027": "APP-CP-027",
  "BUTP316": "APP-TP-316",
  "BUTP299": "APP-TP-299",
  "BUCP019": "APP-CP-019",
  "BUCP466": "APP-CP-466",
  "BUIF024": "APP-IF-024",
  "BUCP168": "APP-CP-168",
  "BUIT129": "APP-IT-129",
  "BUTP088": "APP-TP-088",
  "BUIT124": "APP-IT-124",
  "BUCP347": "APP-CP-347",
  "MRK007": "SYS-MRK007",
  "BUML018": "APP-ML-018",
  "BUIF016": "APP-IF-016",
  "BUTP285": "APP-TP-285",
  "BUTP347": "APP-TP-347",
  "NUOVA BUTP 7": "SYS-NUOVA BUTP 7",
  "BUCP009": "APP-CP-009",
  "BUIT122": "APP-IT-122",
  "BUML041": "APP-ML-041",
  "BUIT128": "APP-IT-128",
  "BUTP143": "APP-TP-143",
  "BUML053": "APP-ML-053",
  "BUIT280": "APP-IT-280",
  "BUIT112": "APP-IT-112",
  "BUIF224": "APP-IF-224",
  "BUCP333": "APP-CP-333",
  "BUCP392": "APP-CP-392",
  "BUIF255": "APP-IF-255",
  "BUTP269": "APP-TP-269",
  "BUTP310": "APP-TP-310",
  "BUCP460": "APP-CP-460",
  "BUTP332": "APP-TP-332",
  "BUTP306": "APP-TP-306",
  "BUIT123": "APP-IT-123",
  "BUCP393": "APP-CP-393",
  "BUML045": "APP-ML-045",
  "BUIT135": "APP-IT-135",
  "BUML037": "APP-ML-037",
  "BUCP472": "APP-CP-472",
  "BUTP045": "APP-TP-045",
  "BUIF134": "APP-IF-134",
  "BUTP247": "APP-TP-247",
  "BUIF254": "APP-IF-254",
  "BUIF215": "APP-IF-215",
  "BUCP498": "APP-CP-498",
  "BUIF502": "APP-IF-502",
  "BUIF123": "APP-IF-123",
  "BUTP212": "APP-TP-212",
  "BUCP477": "APP-CP-477",
  "BUIT118": "APP-IT-118",
  "BUIF525": "APP-IF-525",
  "BUML039": "APP-ML-039",
  "BUML046": "APP-ML-046",
  "BUCP322": "APP-CP-322",
  "BUCP057": "APP-CP-057",
  "BUTP349": "APP-TP-349",
  "BUIT106": "APP-IT-106",
  "BUML061": "APP-ML-061",
  "FSTINF002": "SYS-FSTINF002",
  "BUIF090": "APP-IF-090",
  "BUIF501": "APP-IF-501",
  "BUTP274": "APP-TP-274",
  "BUTP259": "APP-TP-259",
  "BUCP161": "APP-CP-161",
  "BUIF274": "APP-IF-274",
  "BUTP251": "APP-TP-251",
  "BUCP058": "APP-CP-058",
  "BUCP079": "APP-CP-079",
  "BUCP162": "APP-CP-162",
  "BUIF219": "APP-IF-219",
  "BUIT127": "APP-IT-127",
  "BUML042": "APP-ML-042",
  "BUML038": "APP-ML-038",
  "BUCP060": "APP-CP-060",
  "BUCP463": "APP-CP-463",
  "BUCP309": "APP-CP-309",
  "BUIF062": "APP-IF-062",
  "BUCP159": "APP-CP-159",
  "BUCP068": "APP-CP-068",
  "BUCP160": "APP-CP-160",
  "Business Application non ancora nota": "SYS-Business Application non ancora nota",
  "BUTP160, BUTP072, BUTP062, BUTP197, BUTP013, BUTP015, BUTP016, BUTP017": "APP-TP-160, APP-TP-072, APP-TP-062, APP-TP-197, APP-TP-013, APP-TP-015, APP-TP-016, APP-TP-017",
  "BUIF057, BUIF013, BUIF244": "APP-IF-057, APP-IF-013, APP-IF-244",
  "BUIF031, BUIF054": "APP-IF-031, APP-IF-054",
  "BUIF249": "APP-IF-249",
  "BUIF269, BUIF042": "APP-IF-269, APP-IF-042",
  "BUCP010, BUCP011, BUCP033, BUCP034": "APP-CP-010, APP-CP-011, APP-CP-033, APP-CP-034",
  "BUIF047": "APP-IF-047",
  "BUIF026, BUIF027": "APP-IF-026, APP-IF-027",
  "BUIF266, BUIF042": "APP-IF-266, APP-IF-042",
  "BUIF269, BUIF117": "APP-IF-269, APP-IF-117",
  "BUIF106, BUIF107": "APP-IF-106, APP-IF-107",
  "BUIF129, BUIF021, BUIF062, BUIF012, BUIF090, BUIF020, BUIF119, BUIF068": "APP-IF-129, APP-IF-021, APP-IF-062, APP-IF-012, APP-IF-090, APP-IF-020, APP-IF-119, APP-IF-068",
  "BUCP360": "APP-CP-360",
  "BUIF050": "APP-IF-050",
  "BUIF035, BUIF097, BUIF098, BUIF099, BUIF100": "APP-IF-035, APP-IF-097, APP-IF-098, APP-IF-099, APP-IF-100",
  "BUTP135, BUTP018": "APP-TP-135, APP-TP-018",
  "BUML006, BUML011, BUML003": "APP-ML-006, APP-ML-011, APP-ML-003",
  "BUCP062, BUCP306": "APP-CP-062, APP-CP-306",
  "BUTP111, BUTP116, BUTP120, BUTP112, BUML044, BUTP048, BUTP023, BUTP113, BUTP115, BUTP109, BUTP107, BUTP104, BUTP158, BUTP105, BUTP103, BUTP118, BUTP117, BUTP119, BUTP108": "APP-TP-111, APP-TP-116, APP-TP-120, APP-TP-112, APP-ML-044, APP-TP-048, APP-TP-023, APP-TP-113, APP-TP-115, APP-TP-109, APP-TP-107, APP-TP-104, APP-TP-158, APP-TP-105, APP-TP-103, APP-TP-118, APP-TP-117, APP-TP-119, APP-TP-108",
  "BUTP025, BUTP200": "APP-TP-025, APP-TP-200",
  "BUIF116, BUIF125, BUIF204, BUIF267": "APP-IF-116, APP-IF-125, APP-IF-204, APP-IF-267",
  "BUTP025, BUTP026": "APP-TP-025, APP-TP-026",
  "BUCP047, BUCP068, BUCP049, BUIF052, BUCP042, BUCP050, BUTP191, BUTP175, BUTP160, BUTP155, BUCP004, BUCP067, BUIF130, BUIF024, BUCP019, BUIF095, BUIF081, BUCP037": "APP-CP-047, APP-CP-068, APP-CP-049, APP-IF-052, APP-CP-042, APP-CP-050, APP-TP-191, APP-TP-175, APP-TP-160, APP-TP-155, APP-CP-004, APP-CP-067, APP-IF-130, APP-IF-024, APP-CP-019, APP-IF-095, APP-IF-081, APP-CP-037",
  "BUCP047, BUCP068, BUCP049, BUIF052, BUCP042, BUCP050, BUTP191": "APP-CP-047, APP-CP-068, APP-CP-049, APP-IF-052, APP-CP-042, APP-CP-050, APP-TP-191",
  "BUIF071, BUIF073, BUIF074, BUIF076, BUIF078, BUIF077, BUIF092, BUIF010, BUIF011, BUIF075, BUIF072, BUIF037, BUIF140": "APP-IF-071, APP-IF-073, APP-IF-074, APP-IF-076, APP-IF-078, APP-IF-077, APP-IF-092, APP-IF-010, APP-IF-011, APP-IF-075, APP-IF-072, APP-IF-037, APP-IF-140",
  "BUTP001, BUTP186, BUTP293": "APP-TP-001, APP-TP-186, APP-TP-293",
  "BUTP112, BUTP186, BUTP174, BUTP141": "APP-TP-112, APP-TP-186, APP-TP-174, APP-TP-141",
  "BUTP048, BUTP112, BUTP023, BUTP108, BUTP001, BUTP186, BUTP293, BUML044, BUTP143": "APP-TP-048, APP-TP-112, APP-TP-023, APP-TP-108, APP-TP-001, APP-TP-186, APP-TP-293, APP-ML-044, APP-TP-143",
  "BUCP049, BUCP042, BUCP045, BUIF052, BUTP175, BUML002": "APP-CP-049, APP-CP-042, APP-CP-045, APP-IF-052, APP-TP-175, APP-ML-002",
  "BUTP175, BUTP191, BUTP193, BUTP155": "APP-TP-175, APP-TP-191, APP-TP-193, APP-TP-155",
  "BUIF287": "APP-IF-287",
  "BUIF125, BUIF084": "APP-IF-125, APP-IF-084",
  "BUTP112, BUTP081": "APP-TP-112, APP-TP-081",
  "BUTP015, BUTP149, BUTP190, BUTP197, BUTP199": "APP-TP-015, APP-TP-149, APP-TP-190, APP-TP-197, APP-TP-199",
  "BUTP174, BUTP273, BUTP137, BUTP092, BUTP084, BUTP156": "APP-TP-174, APP-TP-273, APP-TP-137, APP-TP-092, APP-TP-084, APP-TP-156",
  "BUTP200, BUTP093": "APP-TP-200, APP-TP-093",
  "BUCP070, BUCP075": "APP-CP-070, APP-CP-075",
  "BUML029, BUML032": "APP-ML-029, APP-ML-032",
  "BUCP004, BUCP045, BUCP042, BUCP049, BUCP050, BUTP011, BUTP175, BUIF052, BUCP068": "APP-CP-004, APP-CP-045, APP-CP-042, APP-CP-049, APP-CP-050, APP-TP-011, APP-TP-175, APP-IF-052, APP-CP-068",
  "5CUFST5003": "7CUSYS5003",
  "5CYFST4006": "7CYSYS4006",
  "5IFITF4009": "7IFSYS4009",
  "5INFST4024": "7INSYS4024",
  "5INFST6001": "7INSYS6001",
  "5SOFSE6001": "7SOSYS6001",
  "5SOFST5020": "7SOSYS5020",
  "5SOFST5043": "7SOSYS5043",
  "5SOFST5044": "7SOSYS5044",
  "5SOFST5046": "7SOSYS5046",
  "5SOFST5050": "7SOSYS5050",
  "5SOFST5058": "7SOSYS5058",
  "5SOFST5062": "7SOSYS5062",
  "5SOFST5066": "7SOSYS5066",
  "5SOFST5074": "7SOSYS5074",
  "5SOFST5078": "7SOSYS5078",
  "5SOFST5083": "7SOSYS5083",
  "5SOFST5084": "7SOSYS5084",
  "5SOFST5087": "7SOSYS5087",
  "5SOFST5091": "7SOSYS5091",
  "5SOFST5093": "7SOSYS5093",
  "5SOFST5094": "7SOSYS5094",
  "5SOFST5095": "7SOSYS5095",
  "5SOFST5096": "7SOSYS5096",
  "5SOFST5100": "7SOSYS5100",
  "5SOFST5101": "7SOSYS5101",
  "5SOFST6001": "7SOSYS6001",
  "5SOFST6004": "7SOSYS6004",
  "5SOFST6005": "7SOSYS6005",
  "5SOFST6006": "7SOSYS6006",
  "5SOFST6007": "7SOSYS6007",
  "5SOFST6009": "7SOSYS6009",
  "5SOFST6010": "7SOSYS6010",
  "5SOFST6011": "7SOSYS6011",
  "5SOFST6012": "7SOSYS6012",
  "5SOFST6013": "7SOSYS6013",
  "5SOFST6014": "7SOSYS6014",
  "5SOFST6016": "7SOSYS6016",
  "5SOFST6017": "7SOSYS6017",
  "5SOFST6018": "7SOSYS6018",
  "5SOFST6019": "7SOSYS6019",
  "5SOFST6021": "7SOSYS6021",
  "5SOFST6022": "7SOSYS6022",
  "5SOFST6023": "7SOSYS6023",
  "5SOFST6024": "7SOSYS6024",
  "5SOFST6025": "7SOSYS6025",
  "5SOFST6028": "7SOSYS6028",
  "5SOFST6029": "7SOSYS6029",
  "5SOFST6031": "7SOSYS6031",
  "5SOFST6037": "7SOSYS6037",
  "5SOFST6039": "7SOSYS6039",
  "5SOFST6041": "7SOSYS6041",
  "5SOFST6042": "7SOSYS6042",
  "5SOFST6044": "7SOSYS6044",
  "5SOFST6045": "7SOSYS6045",
  "5SOFST6046": "7SOSYS6046",
  "5SOFST6047": "7SOSYS6047",
  "5SOFST6048": "7SOSYS6048",
  "5SOFST6049": "7SOSYS6049",
  "5SOFST6050": "7SOSYS6050",
  "5SOFST6051": "7SOSYS6051",
  "5SOFST6053": "7SOSYS6053",
  "5SOFST6054": "7SOSYS6054",
  "5SOFST6055": "7SOSYS6055",
  "5SOFST6057": "7SOSYS6057",
  "5SOFST6059": "7SOSYS6059",
  "5SOFST6062": "7SOSYS6062",
  "5SOFST6064": "7SOSYS6064",
  "5SOFST6066": "7SOSYS6066",
  "5SOFST6067": "7SOSYS6067",
  "5SOFST6068": "7SOSYS6068",
  "5SOFST6070": "7SOSYS6070",
  "5SOFST6071": "7SOSYS6071",
  "5SOFST6073": "7SOSYS6073",
  "5SOFST6074": "7SOSYS6074",
  "5SOFST6075": "7SOSYS6075",
  "5SOFST6076": "7SOSYS6076",
  "5SOFST6077": "7SOSYS6077",
  "5SOFST6078": "7SOSYS6078",
  "5SOFST6079": "7SOSYS6079",
  "5SOFST6080": "7SOSYS6080",
  "5SOFST6081": "7SOSYS6081",
  "5SOFST6082": "7SOSYS6082",
  "5SOFST6083": "7SOSYS6083",
  "5SOFST6084": "7SOSYS6084",
  "5SOFST6085": "7SOSYS6085",
  "5SOFST6086": "7SOSYS6086",
  "5SOFST6087": "7SOSYS6087",
  "5SOFST6088": "7SOSYS6088",
  "5SOFST6089": "7SOSYS6089",
  "5SOFST6090": "7SOSYS6090",
  "5SOFST6092": "7SOSYS6092",
  "5SOFST6094": "7SOSYS6094",
  "5SOFST6095": "7SOSYS6095",
  "5SOFST6096": "7SOSYS6096",
  "5SOFST6097": "7SOSYS6097",
  "5SOFST6098": "7SOSYS6098",
  "5SOFST6101": "7SOSYS6101",
  "5SOFST6102": "7SOSYS6102",
  "5SORFI5002": "7SOSYS5002",
  "5SORFI6003": "7SOSYS6003",
  "5SORFI6004": "7SOSYS6004",
  "5SORFI6005": "7SOSYS6005",
  "5SORFI6006": "7SOSYS6006",
  "5SORFI6007": "7SOSYS6007",
  "5SOSEC6001": "7SOSYS6001",
  "5SOSEC6002": "7SOSYS6002",
  "5SOTNI6001": "7SOSYS6001",
  "5SOTNI6003": "7SOSYS6003",
  "5SOTNI6004": "7SOSYS6004",
  "5SOTNI6005": "7SOSYS6005",
  "5SOTNI6007": "7SOSYS6007",
  "5CYFST4002": "7CYSYS4002",
  "5CYFST4003": "7CYSYS4003",
  "5CYFST4004": "7CYSYS4004",
  "5CYFST4007": "7CYSYS4007",
  "5DAFST3001": "7DASYS3001",
  "5DVRFI3006": "7DVSYS3006",
  "5DVRFI3009": "7DVSYS3009",
  "5DVRFI3014": "7DVSYS3014",
  "5DVRFI3015": "7DVSYS3015",
  "5DVRFI4001": "7DVSYS4001",
  "5DVRFI4012": "7DVSYS4012",
  "5DVRFI4020": "7DVSYS4020",
  "5GOFST4001": "7GOSYS4001",
  "5GOFST5001": "7GOSYS5001",
  "5IFFST4001": "7IFSYS4001",
  "5IFITF4010": "7IFSYS4010",
  "5IFITF4011": "7IFSYS4011",
  "5INFST3002": "7INSYS3002",
  "5INFST3025": "7INSYS3025",
  "5INFST3026": "7INSYS3026",
  "5INFST3032": "7INSYS3032",
  "5INFST3044": "7INSYS3044",
  "5INFST3052": "7INSYS3052",
  "5INFST4001": "7INSYS4001",
  "5INFST4023": "7INSYS4023",
  "5INFST4030": "7INSYS4030",
  "5INFST4031": "7INSYS4031",
  "5INFST4054": "7INSYS4054",
  "5INFST4076": "7INSYS4076",
  "5INFST4077": "7INSYS4077",
  "5INFST4080": "7INSYS4080",
  "5INFST4082": "7INSYS4082",
  "5INFST4095": "7INSYS4095",
  "5INFST4102": "7INSYS4102",
  "5INFST4104": "7INSYS4104",
  "5INFST4105": "7INSYS4105",
  "5INFST4107": "7INSYS4107",
  "5INFST4108": "7INSYS4108",
  "5INFST4110": "7INSYS4110",
  "5INRFI4001": "7INSYS4001",
  "5INTNI3003": "7INSYS3003",
  "5INTNI3018": "7INSYS3018",
  "5ITTRN3007": "7ITSYS3007",
  "5ITTRN4002": "7ITSYS4002",
  "5MOFST4001": "7MOSYS4001",
  "5MOFST5002": "7MOSYS5002",
  "5SOFER5002": "7SOSYS5002",
  "5SOFFS6001": "7SOSYS6001",
  "5SOFRC5001": "7SOSYS5001",
  "5SOFST4002": "7SOSYS4002",
  "5SOFST4004": "7SOSYS4004",
  "5SOFST4005": "7SOSYS4005",
  "5SOFST4007": "7SOSYS4007",
  "5SOFST4008": "7SOSYS4008",
  "5SOFST4009": "7SOSYS4009",
  "5SOFST4010": "7SOSYS4010",
  "5SOFST4011": "7SOSYS4011",
  "5SOFST4012": "7SOSYS4012",
  "5SOFST4014": "7SOSYS4014",
  "5SOFST4015": "7SOSYS4015",
  "5SOFST5001": "7SOSYS5001",
  "5SOFST5002": "7SOSYS5002",
  "5SOFST5003": "7SOSYS5003",
  "5SOFST5007": "7SOSYS5007",
  "5SOFST5012": "7SOSYS5012",
  "5SOFST5016": "7SOSYS5016",
  "5SOFST5017": "7SOSYS5017",
  "5SOFST5022": "7SOSYS5022",
  "5SOFST5023": "7SOSYS5023",
  "5SOFST5026": "7SOSYS5026",
  "5SOFST5028": "7SOSYS5028",
  "5SOFST5029": "7SOSYS5029",
  "5SOFST5030": "7SOSYS5030",
  "5SOFST5031": "7SOSYS5031",
  "5SOFST5032": "7SOSYS5032",
  "5SOFST5034": "7SOSYS5034",
  "5SOFST5038": "7SOSYS5038",
  "5SOFST5039": "7SOSYS5039",
  "5SOFST5040": "7SOSYS5040",
  "5SOFST5049": "7SOSYS5049",
  "5SOFST5052": "7SOSYS5052",
  "5SOFST5053": "7SOSYS5053",
  "5SOFST5054": "7SOSYS5054",
  "5SOFST5055": "7SOSYS5055",
  "5SOFST5059": "7SOSYS5059",
  "5SOFST5061": "7SOSYS5061",
  "5SOFST5064": "7SOSYS5064",
  "5SOFST5067": "7SOSYS5067",
  "5SOFST5071": "7SOSYS5071",
  "5SOFST5072": "7SOSYS5072",
  "5SOFST5073": "7SOSYS5073",
  "5SOFST5079": "7SOSYS5079",
  "5SOFST5080": "7SOSYS5080",
  "5SOFST5082": "7SOSYS5082",
  "5SOFST5086": "7SOSYS5086",
  "5SOFST5097": "7SOSYS5097",
  "5SOFST5099": "7SOSYS5099",
  "5SOFST6003": "7SOSYS6003",
  "5SOFST6020": "7SOSYS6020",
  "5SOFST6030": "7SOSYS6030",
  "5SOFST6032": "7SOSYS6032",
  "5SOFST6033": "7SOSYS6033",
  "5SOFST6035": "7SOSYS6035",
  "5SOFST6038": "7SOSYS6038",
  "5SOFST6056": "7SOSYS6056",
  "5SOFST6058": "7SOSYS6058",
  "5SOFST6069": "7SOSYS6069",
  "5SOGSR5003": "7SOSYS5003",
  "5SOIFR5001": "7SOSYS5001",
  "5SOTHE6001": "7SOSYS6001",
  "5SOTNI4001": "7SOSYS4001",
  "5SOTNI5001": "7SOSYS5001",
  "5SOTNI5005": "7SOSYS5005",
  "5SOTNI6002": "7SOSYS6002",
  "5SOTRN5001": "7SOSYS5001",
  "5TPFST4001": "7TPSYS4001",
  "5TPFST4003": "7TPSYS4003",
  "5COFST4001": "7COSYS4001",
  "5DVRFI4015": "7DVSYS4015",
  "5INFST3046": "7INSYS3046",
  "5INFST3053": "7INSYS3053",
  "5INFST4050": "7INSYS4050",
  "5INFST4094": "7INSYS4094",
  "5SOFST6093": "7SOSYS6093",
  "5SOIFR6001": "7SOSYS6001",
  "5CCFST4002": "7CCSYS4002",
  "5CSFST4001": "7CSSYS4001",
  "5CSFST5002": "7CSSYS5002",
  "5CSIFR5001": "7CSSYS5001",
  "5CUFST5001": "7CUSYS5001",
  "5CUFST5002": "7CUSYS5002",
  "5CYFST4001": "7CYSYS4001",
  "5CYFST4005": "7CYSYS4005",
  "5DVRFI3003": "7DVSYS3003",
  "5DVRFI4002": "7DVSYS4002",
  "5DVRFI4018": "7DVSYS4018",
  "5DVRFI4019": "7DVSYS4019",
  "5DVRFI4022": "7DVSYS4022",
  "5INFST4022": "7INSYS4022",
  "5INFST4033": "7INSYS4033",
  "5INFST4041": "7INSYS4041",
  "5INFST4053": "7INSYS4053",
  "5INFST4057": "7INSYS4057",
  "5INFST4060": "7INSYS4060",
  "5INFST4063": "7INSYS4063",
  "5INFST4071": "7INSYS4071",
  "5INFST4073": "7INSYS4073",
  "5INFST4084": "7INSYS4084",
  "5INFST4087": "7INSYS4087",
  "5INFST4088": "7INSYS4088",
  "5INFST4089": "7INSYS4089",
  "5INFST4090": "7INSYS4090",
  "5INFST4091": "7INSYS4091",
  "5INFST4092": "7INSYS4092",
  "5INFST4093": "7INSYS4093",
  "5INFST4098": "7INSYS4098",
  "5INFST4099": "7INSYS4099",
  "5INFST4100": "7INSYS4100",
  "5INFST4103": "7INSYS4103",
  "5INFST4106": "7INSYS4106",
  "5INFST4109": "7INSYS4109",
  "5INFST5004": "7INSYS5004",
  "5INTNI3009": "7INSYS3009",
  "5MOFST5003": "7MOSYS5003",
  "5MOFST5004": "7MOSYS5004",
  "5MOFST5005": "7MOSYS5005",
  "5SOBUS5001": "7SOSYS5001",
  "5SOBUS5002": "7SOSYS5002",
  "5SOFER5001": "7SOSYS5001",
  "5SOFST4001": "7SOSYS4001",
  "5SOFST4003": "7SOSYS4003",
  "5SOFST4006": "7SOSYS4006",
  "5SOFST4013": "7SOSYS4013",
  "5SOFST4016": "7SOSYS4016",
  "5SOFST5004": "7SOSYS5004",
  "5SOFST5006": "7SOSYS5006",
  "5SOFST5010": "7SOSYS5010",
  "5SOFST5011": "7SOSYS5011",
  "5SOFST5015": "7SOSYS5015",
  "5SOFST5019": "7SOSYS5019",
  "5SOFST5021": "7SOSYS5021",
  "5SOFST5024": "7SOSYS5024",
  "5SOFST5036": "7SOSYS5036",
  "5SOFST5037": "7SOSYS5037",
  "5SOFST5041": "7SOSYS5041",
  "5SOFST5045": "7SOSYS5045",
  "5SOFST5047": "7SOSYS5047",
  "5SOFST5048": "7SOSYS5048",
  "5SOFST5060": "7SOSYS5060",
  "5SOFST5069": "7SOSYS5069",
  "5SOFST5070": "7SOSYS5070",
  "5SOFST5077": "7SOSYS5077",
  "5SOFST5081": "7SOSYS5081",
  "5SOFST5088": "7SOSYS5088",
  "5SOFST5089": "7SOSYS5089",
  "5SOIFR4001": "7SOSYS4001",
  "5SOIFR5002": "7SOSYS5002",
  "5SORFI5001": "7SOSYS5001",
  "5SOSEC5002": "7SOSYS5002",
  "5SOTNI5002": "7SOSYS5002",
  "5SOTNI5003": "7SOSYS5003",
  "5SOTNI5004": "7SOSYS5004",
  "5CUFST6001": "7CUSYS6001",
  "5DVRFI4011": "7DVSYS4011",
  "5INFST4065": "7INSYS4065",
  "5MOFST5006": "7MOSYS5006",
  "5SOFST5008": "7SOSYS5008",
  "5SOFST5009": "7SOSYS5009",
  "5SOFST5013": "7SOSYS5013",
  "5SOFST5018": "7SOSYS5018",
  "5SOFST5025": "7SOSYS5025",
  "5SOFST5027": "7SOSYS5027",
  "5SOFST5042": "7SOSYS5042",
  "5SOFST5056": "7SOSYS5056",
  "5SOFST5085": "7SOSYS5085",
  "5SOFST6026": "7SOSYS6026",
  "5SOFST6036": "7SOSYS6036",
  "5SOFST6040": "7SOSYS6040",
  "5SOFST6043": "7SOSYS6043",
  "5SOFST6052": "7SOSYS6052",
  "5SOFST6061": "7SOSYS6061",
  "5SOFST6063": "7SOSYS6063",
  "5SOFST6072": "7SOSYS6072",
  "5SORFI5003": "7SOSYS5003",
  "5SORFI6001": "7SOSYS6001",
  "5SORFI6002": "7SOSYS6002",
  "5SOTNI6008": "7SOSYS6008",
  "5INFRC3001": "7INSYS3001",
  "5SOFST5057": "7SOSYS5057",
  "5SOFST5063": "7SOSYS5063",
  "5SOFST5065": "7SOSYS5065",
  "5SOFST5068": "7SOSYS5068",
  "5SOFST5075": "7SOSYS5075",
  "5SOFST5076": "7SOSYS5076",
  "5SOFST5092": "7SOSYS5092",
  "5SOFST6002": "7SOSYS6002",
  "5IFITF3001": "7IFSYS3001",
  "5INFST3047": "7INSYS3047",
  "5INFST4028": "7INSYS4028",
  "5INFST4042": "7INSYS4042",
  "5INFST4059": "7INSYS4059",
  "5INFST4083": "7INSYS4083",
  "5INFST4101": "7INSYS4101",
  "5INFST5005": "7INSYS5005",
  "5MOFST5007": "7MOSYS5007",
  "5MOSBB5001": "7MOSYS5001",
  "5SMHOL4001": "7SMSYS4001",
  "5SOFST5005": "7SOSYS5005",
  "5SOFST5014": "7SOSYS5014",
  "5SOFST5033": "7SOSYS5033",
  "5SOFST5035": "7SOSYS5035",
  "5SOFST5051": "7SOSYS5051",
  "5SOFST5090": "7SOSYS5090",
  "5SOFST5098": "7SOSYS5098",
  "5SOFST6008": "7SOSYS6008",
  "5SOFST6015": "7SOSYS6015",
  "5SOFST6027": "7SOSYS6027",
  "5SOFST6034": "7SOSYS6034",
  "5SOFST6060": "7SOSYS6060",
  "5SOGSR5001": "7SOSYS5001",
  "5SOGSR5002": "7SOSYS5002",
  "5SOSEC5001": "7SOSYS5001",
  "5SOTNI5006": "7SOSYS5006",
  "5SOTNI5007": "7SOSYS5007",
  "5SOFFS6002": "7SOSYS6002",
  "5SOFST6065": "7SOSYS6065",
  "5SOFST6091": "7SOSYS6091",
  "5SOFST6099": "7SOSYS6099",
  "5SOFST6100": "7SOSYS6100",
  "5SOTNI6006": "7SOSYS6006",
  "FSTH.4478": "INVT.4478",
  "FSTH.0118.S01.RE01_A01": "INVT.0118.S01.RE01_A01",
  "ITAL.05.2024ITAL.05.2025": "INVT.05.2024ITAL.05.2025",
  "ITF.0310": "INVT.0310",
  "FS01.02.2025.S01.A02": "INVT.02.2025.S01.A02",
  "FSE.0039.S10": "INVT.0039.S10",
  "FS01.0021": "INVT.0021",
  "ITF.0391": "INVT.0391",
  "FS01.02.2025": "INVT.02.2025",
  "ITF.0395.S01.RE01.A02": "INVT.0395.S01.RE01.A02",
  "FS01.0053": "INVT.0053",
  "ITF.0295": "INVT.0295",
  "FS01.0019": "INVT.0019",
  "ITF.0288": "INVT.0288",
  "FSTH.0188": "INVT.0188",
  "ITF.08.2025 - ITF.08.2026 FSHD.08.2025 - FSHD.08.2026 FSE.08.2025 - FSE.08.2026 TTI.08.2025 - TTI.08.2026": "INVT.08.2025 - INVT.08.2026 FSHD.08.2025 - FSHD.08.2026 INVT.08.2025 - INVT.08.2026 TTI.08.2025 - TTI.08.2026",
  "ITF.0413": "INVT.0413",
  "FS01.0042": "INVT.0042",
  "ITF.0407": "INVT.0407",
  "FSE.08.2025 – FSE.08.2027, MTPK.08.2025 – MTPK.08.2027, MIL.08.2025 – MIL.08.2027,  ITF.08.2025 - ITF.08.2027": "INVT.08.2025 – INVT.08.2027, MTPK.08.2025 – MTPK.08.2027, MIL.08.2025 – MIL.08.2027,  INVT.08.2025 - INVT.08.2027",
  "FS01.0040": "INVT.0040",
  "FS01.0092.S01": "INVT.0092.S01",
  "FS01.0006": "INVT.0006",
  "MIL.0003": "WBS-MIL.0003",
  "ITF.0416": "INVT.0416",
  "FSTH.0079": "INVT.0079",
  "ITF. 0416": "INVT. 0416",
  "fsth.0119": "WBS-fsth.0119",
  "FS01.0016": "INVT.0016",
  "MIR.0001": "WBS-MIR.0001",
  "FSTH.0119": "INVT.0119",
  "ITF.0399": "INVT.0399",
  "FS01.0041": "INVT.0041",
  "FS01.0057": "INVT.0057",
  "FSTH.0222": "INVT.0222",
  "FSEC.0013.S02": "WBS-FSEC.0013.S02",
  "FOFS.0002.S03.ME01.A01": "WBS-FOFS.0002.S03.ME01.A01",
  "ITF.0382": "INVT.0382",
  "FSTH.0143": "INVT.0143",
  "FS01.0060.S01": "INVT.0060.S01",
  "FSTH.0161": "INVT.0161",
  "FS01.0022": "INVT.0022",
  "ITF.0389.S02": "INVT.0389.S02",
  "FS01.0096": "INVT.0096",
  "FSTH.0189": "INVT.0189",
  "FSTE.0033": "WBS-FSTE.0033",
  "ITF.0293": "INVT.0293",
  "ITF.0265": "INVT.0265",
  "ITF.0114": "INVT.0114",
  "ITF.0523": "INVT.0523",
  "FSTH.0206": "INVT.0206",
  "FS01.0087": "INVT.0087",
  "MIL.004": "WBS-MIL.004",
  "IFT.0418": "WBS-IFT.0418",
  "non necessaria": "WBS-non necessaria",
  "ITF.0265/5014373/10": "INVT.0265/5014373/10",
  "N/A": "WBS-N/A",
  "FS01.0052": "INVT.0052",
  "NA": "WBS-NA",
  "ITF.0417": "INVT.0417",
  "FS01.0026": "INVT.0026",
  "FS01.0059": "INVT.0059",
  "FS01.0081.S01": "INVT.0081.S01",
  "FS01.0034": "INVT.0034",
  "FS01.02.2026.S01.A02": "INVT.02.2026.S01.A02",
  "FS01.0084": "INVT.0084",
  "FS01.0094": "INVT.0094",
  "FSTH.0224.S01": "INVT.0224.S01",
  "ITF.0368": "INVT.0368",
  "Network - 5012561": "WBS-Network - 5012561",
  "TTPE.0002": "WBS-TTPE.0002",
  "FSTH.0183": "INVT.0183",
  "ITF.0102": "INVT.0102",
  "FSTH.0118.S01.RE01.A11": "INVT.0118.S01.RE01.A11",
  "FSTH.0118.S01.PP01.A01": "INVT.0118.S01.PP01.A01",
  "FSTH.0096": "INVT.0096",
  "FS01.0037": "INVT.0037",
  "FS01.0031": "INVT.0031",
  "FS01.0036": "INVT.0036",
  "FS01.0023": "INVT.0023",
  "FS01.0007": "INVT.0007",
  "FSTH.0139": "INVT.0139",
  "FSTH.0036": "INVT.0036",
  "FSTH.0108": "INVT.0108",
  "FSTH.0073": "INVT.0073",
  "FSTH.0122": "INVT.0122",
  "FSTH.0128": "INVT.0128",
  "ITF.0195": "INVT.0195",
  "FSTH.0137": "INVT.0137",
  "ITF.0272 _ ITF. 0347": "INVT.0272 _ INVT. 0347",
  "ITF.0351": "INVT.0351",
  "TIUK.0005": "WBS-TIUK.0005",
  "MIST.0012 – MII.0012": "WBS-MIST.0012 – MII.0012",
  "FS01.0015": "INVT.0015",
  "FS01.0078": "INVT.0078",
  "FS01.0011": "INVT.0011",
  "ITF.0257": "INVT.0257",
  "ITF.0253": "INVT.0253",
  "TLN.0006": "WBS-TLN.0006",
  "ITF.0190": "INVT.0190",
  "MIR.0009": "WBS-MIR.0009",
  "FSTH.0077": "INVT.0077",
  "ITF.0201": "INVT.0201",
  "FSTH.0108 5009802/0010": "INVT.0108 5009802/0010",
  "ITF.0282": "INVT.0282",
  "FS01.0060": "INVT.0060",
  "FSE.0035": "INVT.0035",
  "FSTH.0157.S02.RE01.A01": "INVT.0157.S02.RE01.A01",
  "ITF.0306": "INVT.0306",
  "ITF,0389": "INVT,0389",
  "WBS/CdC \tFSTH.0079": "WBS/CdC \tINVT.0079",
  "ITF.0383": "INVT.0383",
  "fsth 00.79": "WBS-fsth 00.79",
  "FSTH.0179": "INVT.0179",
  "ITF.0025": "INVT.0025",
  "itf.0410": "WBS-itf.0410",
  "ITF.0401": "INVT.0401",
  "ITF.0390": "INVT.0390",
  "FSTH.08.2025 (riferimento FSTH.0079)": "INVT.08.2025 (riferimento INVT.0079)",
  "FSTH.08.2025": "INVT.08.2025",
  "FSTH.0201": "INVT.0201",
  "FSTH.0202.S01.RE01.A01": "INVT.0202.S01.RE01.A01",
  "Vedi ODV": "WBS-Vedi ODV",
  "FSTH.0213.S04": "INVT.0213.S04",
  "MIST.0014": "WBS-MIST.0014",
  "MIL.0009": "WBS-MIL.0009",
  "MIL.0010": "WBS-MIL.0010",
  "MIL.008": "WBS-MIL.008",
  "MII.0017": "WBS-MII.0017",
  "FSTH.0035": "INVT.0035",
  "THEL.0003": "WBS-THEL.0003",
  "ITF.0314": "INVT.0314",
  "FSTH.4416": "INVT.4416",
  "FS01.02.2024": "INVT.02.2024",
  "FSHT.0108 5006821/0010": "WBS-FSHT.0108 5006821/0010",
  "FSHT.0108": "WBS-FSHT.0108",
  "FSTH.4471": "INVT.4471",
  "FSTH.0033": "INVT.0033",
  "FSTH.08.2024": "INVT.08.2024",
  "FSTH.1290.S01.RE01.A01": "INVT.1290.S01.RE01.A01",
  "FSTH.0121.S01.RE01.A01": "INVT.0121.S01.RE01.A01",
  "FSTH.0118.S01.RE01.A07": "INVT.0118.S01.RE01.A07",
  "FSTH. 0189": "INVT. 0189",
  "FS01.0062": "INVT.0062",
  "FS01.0051": "INVT.0051",
  "FS01.0035": "INVT.0035",
  "FS01.0066": "INVT.0066",
  "ITF. 0317": "INVT. 0317",
  "ITF.0321": "INVT.0321",
  "FSE.0032 ITF.0338 TTPE.0006": "INVT.0032 INVT.0338 TTPE.0006",
  "ITF.0343": "INVT.0343",
  "FSTH.4473": "INVT.4473",
  "TTI.0002": "WBS-TTI.0002",
  "ITF.9502": "INVT.9502",
  "Fsth.0077": "WBS-Fsth.0077",
  "TRNS.0004": "WBS-TRNS.0004",
  "FSTH.4486": "INVT.4486",
  "ITF.0358": "INVT.0358",
  "ITF.0362": "INVT.0362",
  "FSTH.0108.S01.RE01.A04": "INVT.0108.S01.RE01.A04",
  "ITF.0316": "INVT.0316",
  "ITF.0384": "INVT.0384",
  "ITF.0365": "INVT.0365",
  "ITF.0385": "INVT.0385",
  "BUSI.005": "WBS-BUSI.005",
  "FSCS.0019": "WBS-FSCS.0019",
  "Network: 5009775/0010 - FSTH.0108": "Network: 5009775/0010 - INVT.0108",
  "ITF.0363": "INVT.0363",
  "FSTH.0108.S01.RE01.A02": "INVT.0108.S01.RE01.A02",
  "ITF.0377": "INVT.0377",
  "ITF.0371": "INVT.0371",
  "ITF.0364": "INVT.0364",
  "FSTH.0159": "INVT.0159",
  "ITF.0387": "INVT.0387",
  "IFT.0281": "WBS-IFT.0281",
  "FSTH.0023": "INVT.0023",
  "FSTH.4491": "INVT.4491",
  "FSTH.0185 - IFR-INFRARAIL.IT": "INVT.0185 - IFR-INFRARAIL.IT",
  "FSTH.4492": "INVT.4492",
  "ITF.0273": "INVT.0273",
  "FSTH.0194": "INVT.0194",
  "ITF.0355": "INVT.0355",
  "FSTH.0178": "INVT.0178",
  "FSEC.0013": "WBS-FSEC.0013",
  "ITF.0370": "INVT.0370",
  "ITF.0274": "INVT.0274",
  "FSTH.4419": "INVT.4419",
  "FS01.0018": "INVT.0018",
  "ITF.0402 5011561 0010": "INVT.0402 5011561 0010",
  "ITF.0375": "INVT.0375",
  "ITF.0381": "INVT.0381",
  "ITF.0323": "INVT.0323",
  "TIUK.0006": "WBS-TIUK.0006",
  "FSTH.0146": "INVT.0146",
  "FSTH.0185": "INVT.0185",
  "ITF.0205": "INVT.0205",
  "PSH.125": "WBS-PSH.125",
  "FS01.0081": "INVT.0081",
  "ITF.901166": "INVT.901166",
  "fsth.0080": "WBS-fsth.0080",
  "ITF.0369": "INVT.0369",
  "ITF.0311": "INVT.0311",
  "FSTH.0191": "INVT.0191",
  "ITF.0101": "INVT.0101",
  "ITAL05.2023": "WBS-ITAL05.2023",
  "MIST.07.2023.S03.A01 - MIST.07.2024.S03.A02": "WBS-MIST.07.2023.S03.A01 - MIST.07.2024.S03.A02",
  "FSTH.0105": "INVT.0105",
  "FOFS.0004": "WBS-FOFS.0004",
  "ITF.0334": "INVT.0334",
  "FS01.0071": "INVT.0071",
  "ITF.0309": "INVT.0309",
  "FSTH.08.2024; ITF.08.2024": "INVT.08.2024; INVT.08.2024",
  "ITF.0322": "INVT.0322",
  "MINERVA0108": "WBS-MINERVA0108",
  "FSTH.0197": "INVT.0197",
  "ITF.0406": "INVT.0406",
  "FSTH.201": "INVT.201",
  "FSTH.0205": "INVT.0205",
  "FSTH.0202": "INVT.0202",
  "ITF.0525 ITF.0526": "INVT.0525 INVT.0526",
  "FSTH.0108.S02": "INVT.0108.S02",
  "ITF.0506": "INVT.0506",
  "TITBC": "NET-BC",
  "TITNOBC": "NET-NOBC",
  "TIT": "TELCO-NET",
  "CTO": "CORE-TECH",
  "TIXL": "NET-XL",
  "TIPLUS": "NET-PLUS",
  "TIPLUS-INT": "NET-PLUS-INT",
  "TIPLUS-NOPROD": "NET-PLUS-NOPROD",
  "TIPLUS-PROD": "NET-PLUS-PROD",
  "TSEV6": "SRV-V6",
  "PIC": "POLAR",
  "POTT": "PL-OCT",
  "PIC POTT": "POLAR PL-OCT",
  "PIC OTT-DIC24": "POLAR PL-Q4",
  "PIC MNS": "POLAR MNS",
  "PIC PIC": "POLAR CORE",
  "PIC PIC LEGACY": "POLAR CORE LEGACY",
  "PIC EX AETA CYBER": "POLAR CYBER SEC",
  "PIC MIGRAZIONE NS NAS_A": "POLAR MIGRAZIONE STORAGE_A",
  "PIC CLUSTER APPLICATIVO MNS_1.4_1.5_1.6": "POLAR CLUSTER MNS_1.4",
  "PICOUK": "POLARIS-UK",
  "PICO4FRANCE": "POLARIS-FRANCE",
  "AETA": "ALTAIR",
  "CSOC": "CYBER-SOC",
  "C-SOC": "CYBER-SOC",
  "NOBC": "NON-BC",
  "FIM": "ID-MGMT",
  "MIDA": "CORE-MIDA",
  "EBRS": "ENTERPRISE-BRS",
  "YMS": "YARD-MGMT",
  "QRADAR": "SIEM-SEC",
  "DYNATRACE": "APM-METRICS",
  "DAM": "DATA-AUDIT",
  "GDE": "GOV-DATA",
  "AVS": "CLOUD-AVS",
  "VST": "V-STACK",
  "VST-FE": "V-STACK-FE",
  "BIDIL": "TR-SYS-B",
  "PDKM": "DATA-KM",
  "COLPOFER": "TRANSIT-SEC",
  "Gruppo Ferrovie dello Stato": "Global Mobility Group",
  "GRUPPO FERROVIE DELLO STATO": "GLOBAL MOBILITY GROUP",
  "gruppo ferrovie dello stato": "global mobility group",
  "Gruppo Ferrovie dello Stato Italiane": "Global Mobility Holding Group",
  "GRUPPO FERROVIE DELLO STATO ITALIANE": "GLOBAL MOBILITY HOLDING GROUP",
  "gruppo ferrovie dello stato italiane": "global mobility holding group",
  "Ferrovie dello Stato": "Global Mobility Holding",
  "FERROVIE DELLO STATO": "GLOBAL MOBILITY HOLDING",
  "ferrovie dello stato": "global mobility holding",
  "Ferrovie dello Stato Italiane": "Global Mobility Holding",
  "FERROVIE DELLO STATO ITALIANE": "GLOBAL MOBILITY HOLDING",
  "ferrovie dello stato italiane": "global mobility holding",
  "Ferrovie dello Stato Italiane S.p.A.": "Global Mobility Holding S.p.A.",
  "FERROVIE DELLO STATO ITALIANE S.P.A.": "GLOBAL MOBILITY HOLDING S.P.A.",
  "FS Italiane": "Global Mobility",
  "FS ITALIANE": "GLOBAL MOBILITY",
  "fs italiane": "global mobility"
};
